export const locale = {
  general_menu_settings: '菜单常规设置',
  settings: {
  business_type_title: '选择菜单业务类型',
  currency_label: '货币',
  show_filter: '显示产品过滤器',
  show_categories: '显示产品类别',
  
  business_types: {
    cafe: '咖啡馆',
    restaurant: '餐厅',
    fastfood: '快餐',
    icecream: '果汁与冰淇淋',
    sweets: '糖果与甜点',
    bakery: '面包店'
  },
  
  custom_labels: {
        ph_menu_cafe: '咖啡厅菜单',
    ph_menu_restaurant: '餐饮菜单',
    ph_menu_fastfood: '快餐菜单',
    ph_menu_icecream: '果汁与冰淇淋',
    ph_menu_sweets: '蛋糕与甜点',
    ph_menu_bakery: '面包与烘焙',
    ph_product_list: '产品',
    ph_add_order: '添加',
    ph_add_cart: '购买',

    title: '自定义标签（可选）',
    subtitle: '用您喜欢的词语替换默认的系统术语。',
    products_title: '产品部分标题',
    ph_food_menu: '例如：食品菜单',
    ph_product_list: '例如：产品列表',
    cart_btn: '结账按钮文本',
    ph_add_order: '例如：添加到订单',
    ph_add_cart: '例如：添加到购物车'
  },

  currencies: {
    toman: '土曼',
    rial: '里亚尔'
  }
},
check_account_balance_and_try_again: '请检查您的账户余额后重试',
problem_with_qr_renewal_request: '提交二维码续期请求时出现问题',

  ERRORS: {
    PhoneIsNotValid: "输入的电话号码无效：例如 09101234567",
    InvalidNumber: "输入的数量无效。",
    NoSelectedLineNumber: "请选择发送线路。",
    EmptyText: "请输入文本。",
    UnknownError: "未知错误",
    TryAgain: "请稍后再试。",
    NoAccountCharge: "余额不足",
    NoAccess: "拒绝访问。",
    PleasebyeAPlane: "请购买套餐。",
    PleaseChargeYourAccount: "请充值您的账户。",
    AccessDenied: "拒绝访问。",
    AccessDeniedDescription: "请联系客服获取更多信息。",
    Error: "错误",
    InvalidText: "无效文本",
    InvalidTextContainsLink: "只有服务线路可以包含链接。",
    NoPhoneToSend: "没有要发送的号码。",
  },
  FORMS: {
    SuccsessFullySended: "知道了",
    DestinationPhone: "收件人号码",
    TestDestinationPhone: "测试电话号码",
    SourceNumber: "发件人号码",
    Text: "文本",
    CharCount: "字符数",
    FarsiCharCount: "波斯语字符数",
    EnglishCharCount: "英文字符数",
    Send: "发送",
    SendTime: "发送时间",
    SendTest: "测试发送",
    SendToTestNumber: "发送到测试号码",
    SmsCount: "短信数量",
    SmsLang: "短信语言",
    Add: "添加",
    FromFile: "从文件添加",
    TestNumber: "测试号码",
    Test: "测试",
    ServiceRelated: "服务相关",
    Price: "白名单发送费用",
    TotalPrice: "总费用",
    NumbersCount: "总号码数",
    BlacklistPrice: "黑名单发送费用",
    BlacklistNumbersCount: "黑名单数量",
    WhitelistNumbersCount: "白名单数量",
    IrancellNumbersBlacklistCount: "Irancell 黑名单数量",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval 黑名单数量",
    IrancellNumbersWhitelistCount: "Irancell 白名单数量",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval 白名单数量",
    NumbersCountToSend: "有效号码数量",
    Search: "搜索",
    Title: "标题",
    RequestTime: "请求时间",
    RequestInformation: "请求信息",
    CreateNewPhoneBook: "创建新电话簿",
    AddPhone: "添加号码",
    Remove: "移除",
  },
  unexpected_error: "发生了意外错误，请重试。",
  luck_wheel_name: "幸运转盘二维码名称",
  update_video: "添加视频画廊",
  edit: "编辑",
  to_top: "从上方",
  to_bottom: "从下方",
  to_left: "从右到左",
  to_right: "从左到右",
  to_top_right: "从下方到右",
  to_top_left: "从下方到左",
  to_bottom_right: "从上方到右",
  to_bottom_left: "从上方到左",
  select_color_gradient: "选择渐变色",
  select_color_solid: "选择纯色",
  gradient_direction: "渐变方向",
  gradient_background: "渐变背景",
  qr_downloaded_successfully: "二维码已成功下载。",
  logo: "标志",
  qr_design_size: "二维码设计与尺寸",
  qr_eye_design: "二维码眼部设计",
  qr_markout: "输出边距",
  frame: "边框",
  ready_card_samples: "现成名片范例",
  ready_card_sample: "现成名片范例",
  remove_default_info: "移除默认信息",
  select_ready_card: "选择现成名片",
  connection_code: "连接码",
  enter_visit_card_info: "输入名片信息",
  info: "信息",
  select_template_design: "选择模板设计",
  qr_address: "二维码网址",
  visit_card_name: "您的名片名称",
  visit_card_name_pro: "您的名片名称",
  download_qr: "下载二维码",
  fast_design: "快速设计",
  professional_design: "专业设计",
  ai_design: "人工智能设计",
  update_qr: "更新二维码",
  fast_design_message: "您已切换至快速码设计。先前设计已于本区完成。",
  professional_design_message: "您已切换至专业码设计。先前设计已于本区完成。",
  scan_me: "扫我",
  visit_card_edited_successfully: "您的名片已成功编辑。",
  customer_club_membership: "客户俱乐部会员",
  qrland: "二维码乐园",
  dynamic: "动态",
  about_us_text:
    "动态二维码特色：\n✔️ 无限编辑\n✔️ 轻松扫描\n✔️ 可限制扫描次数\n✔️ 可加入密码\n✔️ 查看访客统计\n✔️ 更改颜色与外观\n✔️ 数据与安全保护\n✔️ 可加入图片与标志\n✔️ 依业务需求制作专属二维码\n✔️ 导向链接与网站\n✔️ 同时提供二维码与短网址\n✔️ 适用于所有社交平台（离线/在线）\n✔️ 可下载任意格式\n✔️ 可打印于任何材质与尺寸",
  video_gallery: "视频画廊",
  address_text: "北京市朝阳区建国路，过建国桥后，巷弄6号",
  visit_card: "名片",
  qrland_system: "二维码乐园系统",
  qrland_first_system: "首个动态二维码生成系统",
  address: "地址",
  enter_site_link: "输入您想要的网站链接",
  instagram: "Instagram",
  enter_instagram_username: "输入您的用户名",
  whatsapp: "WhatsApp",
  invalid_qr_address: "输入的网址无效！",
  visit_card_created_successfully: "您的名片已成功创建。",
  qr_creation_failed: "二维码创建失败！",
  manage_password: "密码管理",
  hour_limit: "时间限制",
  scan_click_limit: "扫描/点击次数限制",
  redirect_scanner: "重定向扫描者",
  edit_settings_error: "编辑设置时发生错误！",
  next: "下一步",
  add: "新增",
  header_color_settings: "页眉颜色与文字设置",
  select_image: "选择图片",
  enter_qr_address: "输入您的二维码网址",
  qr_idea_title: "二维码创作构想",
  qr_idea: "二维码构想",
  qr_idea_subject: "二维码创作主题",
  confirm_qr_idea: "确认我的二维码构想",
  scannable: "可扫描",
  ai_sample: "人工智能生成范例...",
  scan_warning: "可能无法在所有设备上扫描。若无法扫描，请重新尝试。",
  ai_description: "输入您想要的二维码描述，人工智能将为您生成。",
  attach: "附加",
  remaining: "剩余",
  qr_creation: "二维码生成",
  free: "免费",
  select_language_for_request: "选择请求文字语言",
  request_text: "请求文字",
  request_text_placeholder: "描述您想要的二维码链接...",
  strengthen_text: "强化现有文字",
  prompt_idea: "提示构想",
  try_again: "再次尝试",
  create_qr: "创建二维码",
  smart_qr_code: "智能二维码",
  regenerate_image: "重新生成图片",
  updating_qr: "正在更新二维码...",
  copied: "已复制",
  copy: "复制",
  print_qr: "打印二维码",
  print_visit_card: "打印名片",
  send_link: "发送链接",
  customer_list: "客户清单",
  order_list: "订单清单",
  reserved_appointments: "已预约时段",
  feedback: "意见反馈",
  request_form: "请求表单",
  transfer_ownership: "转移所有权",
  select_nfc_card: "选择NFC卡",
  created_at: "创建于",
  last_edit: "最后编辑",
  qr_card: "二维码卡",
  viewed: "已查看",
  see_more: "查看更多",
  download: "下载",
  activate: "启用",
  design: "设计",
  qr_settings: "二维码设置",
  deactivate: "停用",
  qr_color_size: "二维码颜色与尺寸",
  dots_design_color: "点阵设计与颜色",
  eye_design_color: "眼部设计与颜色",
  border_design_color: "边框设计与颜色",
  logo_settings: "标志设置",
  download_qr_comment: "下载二维码",
  connection_established: "连接已建立。",
  show_qr: "显示二维码",
  preview: "预览",
  user_info: "用户信息",
  sms_club_membership: "短信俱乐部会员",
  smart_settings: "智能设置",
  add_audio_file: "新增音频文件",
  back: "返回",
  after_click_location: "点击位置后，选择您的地图应用。",
  phone_number: "电话号码",
  auto_display: "自动显示",
  customer_club: "客户俱乐部",
  auto_download: "自动下载",
  save: "保存",
  about_us: "关于我们",
  view_more: "查看更多",
  view_less: "查看较少",
  audio_file: "音频文件",
  add_video: "新增视频",
  add_image: "新增图片",
  select_color: "选择颜色",
  header_color: "页眉文字",
  add_social_networks: "新增社交网络",
  format: "格式",
  output_size: "输出尺寸",
  file_type: "文件类型",
  default: "默认",
  qr_download_error: "下载二维码时发生问题。请重新尝试",
  header_color_text_settings: "页眉颜色与文字设置",
  upload_catalog_images: "上传目录/手册图片",
  delete: "删除",
  personal_domain: "个人域名",
  no_domain_found: "未找到域名！",
  enter_domain_address: "请输入您的域名地址",
  dns_setup_note: "请记得先设置服务器DNS！",
  attention: "注意：",
  dns_setup_instruction: "要注册个人域名，请先设置DNS",
  and: "与",
  setup_on_domain: "于您的域名上。",
  dns_change_time: "（DNS变更最多需24小时）",
  add_domain: "新增域名",
  add_personal_domain: "新增个人域名",
  min_characters: "最小输入字符数",
  domain_format:
    "网站域名需为 https://terminalads.com 或 terminalads.com 格式。",
  invalid_domain: "输入的域名无效！",
  domain_added_successfully: "您的域名已成功新增",
  invalid_dns_settings: "DNS设置无效！",
  deleted_successfully: "已成功删除",
  location: "位置",
  save_contact: "保存联系人",
  search: "搜索",
  data_fetch_error: "获取数据时发生错误！",
  error: "错误",
  view_qr: "查看二维码",
  qr_design: "二维码设计",
  register: "注册",
  terminal_ads: "终端广告",
  manage_40_advertising_methods: "同时管理40种广告方式！",
  ms_khansari: "康萨里女士",
  support: "支持",
  comprehensive_advertising_system: "唯一全面检测与管理在线广告的系统",
  terminal_ads_description:
    "终端广告系统以持续且有效的客户与用户沟通为荣，旨在理解其需求并提供最佳解决方案。我们最大的资本是忠诚的客户与用户，其次是拥有新颖创意与现代技术支持公司的专家团队。",
  please_enter_qr_address_correctly: "请正确输入二维码网址！",
  server_error: "服务器错误！",
  please_enter_your_address: "请输入您的地址",
  please_enter_instagram_address: "请输入您的Instagram地址",
  please_enter_whatsapp_address: "请输入您的WhatsApp地址",
  enter_information: "输入信息",
  dynamic_qr: "动态二维码",
  coming_soon: "即将推出",
  qr_name: "二维码名称",
  for_default_address_leave_empty: "！使用默认网址请留空",
  default_address: "默认网址",
  sms: "短信",
  enter_number_without_zero: "输入号码不含0。",
  number: "号码",
  country_code: "国家码：",
  sms_text: "短信内容",
  complete_sms_fields_correctly: "请正确填写短信字段！",
  qr_code_created_successfully: "您的二维码已成功创建。",
  chat: "聊天",
  call: "打电话",
  please_enter_username: "请输入用户名。",
  username: "用户名",
  sample_menu: "示例菜单",
  online_menu_name: "您的在线菜单名称",
  online_menu_name_short: "在线菜单",
  enter_menu_information: "输入菜单信息",
  select_sample_menu: "选择示例菜单",
  select_ready_menu: "选择现成菜单",
  online_sales: "在线销售",
  sales_settings: "销售设置",
  photo_gallery: "图片库",
  fast_food1: "快餐1",
  fast_food2: "快餐2",
  products: "产品",
  pizzas: "披萨",
  pizza_rust_beef: "烤牛肉披萨",
  italian_pizza_with_beef: "意大利牛肉披萨",
  italian_pizza_dough_30cm: "意大利披萨面团 30厘米",
  "100g_shredded_beef": "100克牛肉丝",
  mushroom_bell_pepper: "蘑菇，甜椒",
  black_olives: "黑橄榄",
  pizza_chicken_mushroom: "鸡肉蘑菇披萨",
  classic_40cm: "经典 40厘米",
  fresh_tomato_sauce: "新鲜番茄酱，奶酪，鸡肉片，蘑菇，山百里香",
  pizza_meat_mushroom: "肉蘑菇披萨",
  meat_pizza_with_mushroom: "肉馅蘑菇披萨",
  pizza_vegetables: "蔬菜披萨",
  american_vegetable_pizza: "美式蔬菜披萨",
  american_pizza_dough:
    "美式披萨面团，玉米，蘑菇，橄榄，番茄，洋葱，甜椒，奶酪",
  special_pizza: "特色披萨",
  american_special_pizza: "美式特色披萨",
  pizza_bolognese: "波洛尼亚披萨",
  one_person_23cm: "(1人) 披萨面团 23厘米",
  pepperoni_pizza: "意大利辣香肠披萨",
  one_person_23cm_dough: "(1人) 披萨面团 23厘米",
  bacon_pizza: "培根披萨",
  one_person_23cm_explosion: "(1人) 披萨面团 23厘米",
  mixed_pizza: "杂锦披萨",
  one_person_23cm_mixed: "(1人) 披萨面团 23厘米",
  american_steak_pizza: "美式牛排披萨",
  one_person_23cm_steak: "(1人) 23厘米",
  burgers: "汉堡",
  cheese_burger: "奶酪汉堡",
  with_french_fries: "配薯条",
  "2_beef_burgers_150g": "2个150克牛肉汉堡",
  special_sauce_gouda_cheese: "特色酱，豪达奶酪",
  pickles_lettuce_tomato: "腌黄瓜，生菜，番茄",
  special_sauce: "特色酱",
  burger: "汉堡",
  pure_meat_with_special_sauce: "特色酱纯肉",
  chicken_burger: "鸡肉汉堡",
  grilled_chicken_burger_with_cheese: "烤鸡奶酪汉堡",
  spicy_burger: "辣味汉堡",
  beef_with_spicy_sauce: "辣酱牛肉",
  double_burger: "双层汉堡",
  "150g_beef": "150克牛肉",
  royal_burger: "皇家汉堡",
  "150g_beef_emoji": "150克牛肉",
  mushroom_burger: "蘑菇汉堡",
  "150g_beef_mushroom": "150克牛肉蘑菇",
  mushroom_burger_grilled: "烤蘑菇汉堡",
  "100_percent_grilled_beef": "100%烤牛肉",
  fried_burger: "炸汉堡",
  "100_percent_grilled_fried": "100%烤炸牛肉",
  fried: "炸",
  fried_chicken: "炸鸡",
  "3_piece_fried_chicken": "3块炸鸡",
  "3_fried_chicken_pieces": "3块炸鸡",
  "120_150g_french_fries": "120-150克薯条",
  enter_product_information: "输入产品信息",
  product_name: "您的产品名称",
  product_name_short: "产品名称",
  complete_features_from_image: "根据产品图片填写特性",
  skip_step: "跳过此步",
  product_and_information: "产品与信息",
  product_introduction: "产品介绍",
  shiva_waves: "湿婆之波",
  think_best: "想得更好...",
  iran_zanjan_abhar: "伊朗，赞詹，阿巴尔，谢里夫工业区，63/20千伏变电站旁",
  video_gallery_description: "观看我们的视频。",
  gallery: "图库",
  welcome: "欢迎",
  invalid_address: "输入的地址无效！",
  product_created_successfully: "您的产品已成功创建。",
  qr_visit_card_edited_successfully: "您的名片已成功编辑。",
  change_header_color: "更改标题颜色",
  change_body_color: "更改正文颜色",
  change_button_colors: "更改按钮颜色",
  change_text_colors: "更改文本颜色",
  gradient_colors: "渐变颜色",
  color_direction: "颜色方向",
  first_color: "第一种颜色",
  second_color: "第二种颜色",
  color: "颜色",
  text_color: "文本颜色",
  from_top: "从上",
  from_bottom: "从下",
  from_left_to_right: "从左到右",
  from_right_to_left: "从右到左",
  from_top_to_left: "从左上",
  from_top_to_right: "从右上",
  from_bottom_to_left: "从左下",
  from_bottom_to_right: "从右下",
  sharing: "分享",
  business_shop: "商业/店铺",
  corporate_organizational: "公司/组织",
  customer_contact: "客户联系",
  information: "信息",
  miscellaneous: "其他",
  link: "链接",
  margin: "边距",
  width: "宽度",
  height: "高度",
  background_color: "背景颜色",
  gradient_color: "渐变颜色",
  linear: "线性",
  radial: "径向",
  color_rotation: "颜色旋转",
  background_color_label: "背景颜色",
  dots_color: "点颜色",
  dots_color_label: "点颜色",
  eye_colors: "眼睛颜色",
  separate_colors_for_each_eye: "每只眼睛单独颜色",
  current_mode: "当前模式：",
  separate_colors: "单独颜色",
  same_color: "相同颜色",
  all_eyes_color: "所有眼睛颜色",
  top_right_eye: "右上眼",
  top_left_eye: "左上眼",
  bottom_left_eye: "左下眼",
  upload_logo: "上传标志",
  hide_background_dots: "隐藏标志后点",
  logo_size: "标志大小",
  logo_margin: "标志边距",
  qr_accuracy: "二维码精度",
  mode: "模式",
  error_correction_level: "错误更正级别",
  numeric: "数字",
  alphanumeric: "字母数字",
  byte: "字节",
  apply_changes: "应用更改",
  please_click_apply_changes: "选择修改后点击“应用更改”。",
  created_qr_codes: "已创建的二维码",
  square_ratio: "1:1（正方形）",
  image_upload_error: "图片上传错误！",
  visit_card_name_label: "名片名称",
  sms_membership_message: "客户俱乐部会员短信",
  admin_menu: "管理员菜单",
  user_menu: "用户菜单",
  guide_tooltip: "指南",
  close: "关闭",
  browser_video_support_error: "您的浏览器不支持任何视频格式。",
  video_loading_error: "视频加载错误（可能访问受限）。",
  click_more_for_videos: "点击“更多”查看更多视频。",
  more_info: "更多信息",
  more: "更多",
  add_user_guide: "添加用户指南",
  edit_user_guide: "编辑用户指南",
  display_info: "显示信息",
  element: "元素",
  disable_attach: "禁用页面贴合",
  view: "查看",
  guide: "指南",
  details: "详情",
  guide_images: "指南图片",
  guide_videos: "指南视频",
  faq: "常见问题",
  data_preload_error: "数据预加载错误：",
  guide_not_found: "未找到指南。请先创建指南。",
  delete_guide_question: "删除指南？",
  delete_guide_error: "删除指南错误！",
  unknown_file_type: "未知文件类型：",
  content_type_error: "获取内容类型错误：",
  video: "视频",
  image: "图片",
  guide_data_error: "获取指南数据错误：",
  add_iranian_stores: "添加伊朗商店",
  add_foreign_stores: "添加外国商店",
  bazaar: "巴扎",
  myket: "麦凯特",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "三星商店",
  xiaomi_store: "小米商店",
  vivo_store: "Vivo商店",
  amazon_store: "亚马逊商店",
  bazaar_app: "巴扎应用",
  bazaar_link_placeholder: "输入巴扎应用链接",
  bazaar_link_hint:
    "输入有效的巴扎链接（例如：https://cafebazaar.ir/app/com.abankefarda）",
  myket_app: "麦凯特应用",
  myket_link_placeholder: "输入麦凯特应用链接",
  myket_link_hint:
    "输入有效的麦凯特链接（例如：myket://details?id=com.example）",
  app_store_app: "App Store应用",
  app_store_link_placeholder: "输入App Store应用链接",
  app_store_link_hint:
    "输入有效的App Store链接（例如：https://apps.apple.com/us/app/appname/id123456789）",
  google_play_app: "Google Play应用",
  google_play_link_placeholder: "输入Google Play应用链接",
  google_play_link_hint:
    "输入有效的Google Play链接（例如：https://play.google.com/store/apps/details?id=com.example）",
  samsung_store_app: "三星商店应用",
  samsung_store_link_placeholder: "输入三星商店应用链接",
  samsung_store_link_hint:
    "输入有效的三星商店链接（例如：https://galaxy.store/appname）",
  xiaomi_store_app: "小米商店应用",
  xiaomi_store_link_placeholder: "输入小米商店应用链接",
  xiaomi_store_link_hint: "输入有效的小米商店链接",
  vivo_app_store: "Vivo应用商店",
  vivo_app_store_app: "Vivo应用商店应用",
  vivo_app_store_link_placeholder: "输入Vivo应用商店链接",
  vivo_app_store_link_hint: "输入有效的Vivo应用商店链接",
  amazon_store_app: "亚马逊商店应用",
  amazon_store_link_placeholder: "输入亚马逊商店应用链接",
  amazon_store_link_hint: "输入有效的亚马逊商店链接",
  iranian_store: "伊朗商店",
  foreign_store: "外国商店",
  personal_store: "个人商店",
  image_logo: "图片/标志",
  image_gallery: "图片库",
  header_image: "标题图片",
  template_background_image: "模板背景图片",
  background_image: "背景图片",
  background_image_alt: "背景图片",
  logo_upload: "上传标志",
  welcome_image: "欢迎图片",
  welcome_image_logo_upload: "上传欢迎图片/标志",
  loading_animation: "加载动画",
  preview_welcome_page: "预览欢迎页面",
  max_background_size: "最大背景图片大小：2MB。",
  max_logo_size: "最大标志大小：2MB。",
  scale_from_center: "从中心缩放",
  slide_from_left: "从左滑动",
  slide_from_top: "从上滑动",
  fade: "淡入淡出",
  select_music_card: "选择音乐卡",
  show_audio: "显示音频",
  hide_audio: "隐藏音频",
  add_voice: "添加语音",
  max_files_limit: "您不能选择超过 {count} 个文件！",
  files_not_allowed: "不允许文件！",
  voice_gallery: "语音库",
  edit_voice: "编辑语音",
  list: "列表",
  file_name: "文件名",
  title: "标题",
  description: "描述",
  selectdate: "选择日期",
  background: "背景",
  text: "文本",
  delete_audio_confirm: "您确定要从您的库中删除音频文件吗？",
  add_voice_gallery: "添加语音库",
  gallery_number: "库",
  delete_confirm: "您确定要删除吗？",
  confirm: "确认",
  voice_gallery_title_hint: "输入您的语音库标题。",
  voice_gallery_title: "标题",
  voice_gallery_subtitle_hint: "输入您的语音库副标题。",
  voice_gallery_subtitle: "语音库副标题",
  voice_gallery_subtitle_alt: "副标题",
  website_address_hint: "输入您的网站地址。",
  website_address: "网站地址",
  about_voice_gallery: "关于库",
  about_voice_gallery_alt: "关于库",
  button_name_hint: "输入按钮名称。",
  button_name: "按钮名称",
  domain_format_hint: "域名必须是 https://terminalads.com 或 terminalads.com。",
  about_us_alt: "关于我们",
  add_default_form: "添加默认表单",
  delete_all: "删除全部",
  validation_active: "验证：启用",
  validation_inactive: "验证：禁用",
  validation: "验证",
  clear_form: "清除表单",
  status: "状态",
  active: "启用",
  inactive: "禁用",
  optional: "可选",
  required: "必填",
  question_title: "标题",
  question_title_hint: "输入问题标题",
  options_hint: "写下选项并按回车添加",
  options: "选项",
  add_suggested_form: "添加建议表单",
  save_changes: "保存更改",
  add_request_field: "添加请求字段",
  select_form_type: "选择表单类型",
  select_form_type_placeholder: "选择表单类型",
  dropdown: "下拉菜单",
  text_field: "文本字段",
  number_field: "数字字段",
  textarea_field: "文本区域",
  date_field: "日期字段",
  field_name_required: "字段名称不能为空",
  field_name: "字段名称",
  add_field_name: "添加字段名称",
  field_label: "字段标签",
  add_field_label: "添加字段标签",
  advanced_settings: "高级设置",
  select_input_pattern: "选择输入模式",
  select_input_pattern_placeholder: "选择输入模式",
  max_characters: "最大字符数",
  min_input_error: "最小输入必须为0",
  name_field: "姓名",
  field_type: "字段类型",
  persian_limit: "波斯语限制",
  family_name: "姓氏",
  mobile_number: "手机号码",
  number_limit: "数字限制",
  national_code: "国家代码",
  meli_code: "国家代码",
  email: "电子邮件",
  email_limit: "电子邮件限制",
  dropdown_field: "下拉字段",
  english_limit: "英语限制",
  mix_per_eng_limit: "波斯语与英语混合限制",
  site_limit: "网站限制",
  form_added_successfully: "新表单已成功添加",
  form_updated_successfully: "表单已成功更新",
  delete_item_confirm: "您确定要删除此项吗？",
  default_form_added_successfully: "默认表单已成功添加",
  resources_upload_error: "资源上传错误",
  update_value_if_duplicate: "重复时更新值",
  first_tab: "第一个标签页",
  display_count: "显示数量",
  buy_renew_qr_instruction: "要购买/续订二维码，请点击到期日期按钮。",
  days_until_expiry: "到期剩余天数",
  expired: "已过期",
  no_qr_to_display: "没有二维码可显示！",
  second_tab: "第二个标签页",
  total_qr_codes: "总二维码数",
  select_all: "全选",
  selected_qr_codes_count: "已选二维码数",
  qr_codes_count: "二维码数量",
  group_renewal_instruction: "要批量续订，请选择所需的二维码。",
  no_qr_found_with_filters: "未找到符合这些过滤条件的二维码！",
  qr_codes_count_label: "二维码数量：",
  renew_qr: "续订二维码",
  days: "天",
  buy_now: "立即购买！",
  buy_now_label: "购买",
  add_discount_code: "添加折扣码",
  use_discount_code: "使用折扣码",
  discount_code: "折扣码",
  submit: "提交",
  my_qr_list: "我的二维码列表",
  group_renewal: "批量续订",
  row: "行",
  type: "类型",
  clicks: "点击",
  created_at_diff: "创建时间",
  updated_at_diff: "更新时间",
  table_view: "表格视图",
  normal_view: "普通视图",
  no_qr_or_id_selected: "未选择二维码或ID！",
  qr_updated_successfully: "二维码已成功更新。",
  qr_update_error: "更新二维码错误！",
  no_qr_selected: "未选择二维码！",
  no_qr_code_selected: "未选择二维码！",
  success: "成功",
  qrs_upgraded_successfully: "您的二维码已成功升级。",
  qr_renewal_error: "二维码续订请求问题！",
  changed_successfully: "已成功更改。",
  error_occurred: "发生错误！",
  no_tariff_exists: "此期间无资费！",
  qr_upgraded_successfully: "您的二维码已成功升级。",
  check_account_balance: "请检查账户余额并稍后重试。",
  group_renewal_price_error: "获取批量续订价格错误！",
  qr_count_error: "获取二维码数量错误！",
  no_qr_for_renewal: "没有二维码可续订！",
  table_pagination: "表格分页",
  virtual_scroll_display: "虚拟滚动显示",
  popups_shared_components: "弹窗和共享组件",
  edit_qr_address: "编辑二维码地址",
  please_enter_correct_address: "请输入正确地址",
  successfully_edited: "已成功编辑。",
  error_editing_qr_address: "编辑二维码地址错误！",
  go_to_page: "转到页面",
  page_from_to: "第 {current} 页 / 共 {last} 页",
  display: "显示",
  to: "到",
  from: "从",
  show: "显示",
  page_status: "第 {current} 页 / 共 {total} 页",
  until: "直到",
  successfully_completed: "已成功完成",
  problem_occurred: "出现问题",
  download_failed: "下载失败",
  audio_file_default: "音频文件",
  memory_release: "释放内存",
  seek_music_comment: "例如，这首音乐或寻找的东西",
  all: "全部",
  create_podcast: "创建播客",
  add_link: "添加链接",
  upload_file: "上传文件",
  file_list: "文件列表",
  count: "数量",
  select_category: "选择类别",
  after_typing_enter: "输入后按回车。",
  no_image_available: "图片不可用",
  no_image_found: "未找到图片！",
  for_adding_file_use_upload_center: "要添加文件，请使用上传区域或上传中心",
  ai_story_creation_description: "输入您的故事，AI将为您创建",
  create_new_podcast: "创建新播客",
  show_audio_file: "显示音频文件",
  cancel: "取消",
  no_audio_in_category: "此类别中无音频",
  health_apple: "健康苹果",
  standard: "标准",
  arshia_badge: "阿尔希亚徽章",
  home_appliances_association: "家电协会",
  energy_label: "能源标签",
  select_gold_purity_first: "要获取价格，请先选择黄金纯度",
  gold_price_service: "黄金价格服务",
  rahvard: "拉赫瓦德",
  to_change_gold_service_go_to_assets: "要更改黄金价格服务，请转到资产",
  gold: "黄金",
  purity: "纯度",
  rial: "里亚尔",
  final_product_price: "最终产品价格",
  show_images_right_side: "右侧显示图片",
  show_as_slider: "以滑块显示",
  show_as_grid: "以网格显示",
  show_as_second_mode: "以第二模式显示",
  gallery_name: "库名称",
  change_gallery_name: "更改库名称",
  add_photo: "添加照片",
  select_photo: "选择照片",
  show_image: "显示图片",
  selected_photo: "已选照片",
  to_use_ready_images_search_category_or_product:
    "要使用现成图片，请在上方搜索类别或产品。",
  max_file_size_2mb: "最大文件大小：2MB。",
  drag_and_drop_to_upload_or: "拖放上传或",
  here: "此处",
  click: "点击",
  to_use_external_image_link_fill_fields: "要使用外部图片链接，请填写以下字段",
  image_url_hint: "所需图片URL（链接）。",
  image_url: "图片链接",
  add_new_gallery: "添加新库",
  create_image: "创建图片",
  ready_images: "现成图片",
  edit_image: "编辑图片",
  enter_valid_link: "输入有效链接。",
  max_background_image_size_2mb: "最大背景图片大小：2MB。",
  uploaded_successfully: "已成功上传。",
  banner: "横幅",
  question: "问题",
  selected_question: "已选问题",
  answer: "答案",
  add_question: "添加问题",
  selected_blog: "已选博客",
  icon: "图标",
  select_icon: "选择图标",
  add_blog: "添加博客",
  post: "帖子",
  selected_services: "已选服务",
  add_new_post: "添加新帖子",
  add_new_services: "添加新服务",
  add_new_service: "添加新服务",
  domain_must_be_https_or_http:
    "域名必须是 https://terminalads.com 或 terminalads.com。",
  id: "ID",
  images: "图片",
  tags: "标签",
  print_type: "打印类型",
  user: "用户",
  user_shipping_info: "用户配送信息",
  qr_short_link: "二维码短链接",
  delivery_method: "配送方式",
  delivery_at_company: "公司配送",
  delivery_by_post: "邮寄配送",
  post_cost_and_tax_warning: "注册时将从您的钱包扣除邮费和10%税。",
  shipping_info: "配送信息",
  continue_shopping: "继续购物",
  complete_shopping: "完成购买",
  select_free_nfc_card: "选择免费NFC卡",
  order_custom_nfc_card: "订购自定义NFC卡",
  buy_qr_equipment: "购买二维码设备",
  vertical: "垂直",
  horizontal: "水平",
  card_type: "卡类型",
  tag: "标签",
  select: "选择",
  order_card: "订购卡",
  available: "可用",
  unavailable: "不可用",
  for_initial_loading: "用于初始加载",
  already_have_free_nfc_message:
    "您已为此二维码获得免费NFC。要更改，请购买自定义卡。",
  nfc_in_delivery_process_message:
    "您已注册免费NFC，正在配送中。要更改，请购买自定义卡。",
  free_nfc_card_warning_message:
    "尊敬的用户：免费NFC卡为预印，您的二维码会更改。如已使用，请购买自定义卡。",
  select_card: "选择卡",
  free_card_selection_conditions: "免费卡选择条件",
  confirm_and_select: "确认并选择",
  registered_successfully: "已成功注册。",
  error_registering_nfc_order: "注册NFC卡订单错误！",
  nfc_physical_card_orders: "物理NFC卡订单",
  buy_equipment: "购买设备",
  select_quantity: "选择数量",
  ready_samples: "现成样本",
  upload_custom_design: "上传自定义设计",
  select_ready_card_image: "选择现成卡图片",
  select_card_front_image: "选择卡正面图片",
  select_card_back_image: "选择卡背面图片",
  nfc_card_image: "NFC卡图片",
  add_quantity: "添加数量",
  total_price: "总价",
  price_with_discount: "折扣价",
  shipping_cost: "运费",
  your_profit_from_purchase: "您从购买中获利",
  discount: "折扣",
  ten_percent_tax_will_be_added: "将向最终金额添加10%税。",
  payable_amount: "应付金额",
  continue: "继续",
  Confirm_code: "确认码",
  form_success_message: "您的表单已成功提交",
  refill_form_message: "请重新填写表单",
  Enter_the_sent_code: "输入发送给您的代码",
  SUBMIT_FORM: "提交表单",
  enter_phone_number: "输入您的手机号码",
  order_registered_successfully: "您的订单已成功注册。",
  smart_creation: "智能创建",
  automatic_creation: "自动创建",
  business_name: "商业名称",
  example_household_goods: "示例：家居用品",
  organization_name: "组织名称",
  example_tech_company: "示例：先进技术公司",
  minimum_two_characters_required: "至少需要两个字符！",
  maximum_100_characters_allowed: "最多100个字符",
  latin_name_qr_address: "拉丁名称（二维码地址）",
  example_advanced_tech: "示例：advanced-tech",
  only_english_numbers_dash_allowed: "仅允许英文、数字和连字符",
  maximum_50_characters_allowed: "最多50个字符",
  latin_name_goes_after_domain: "拉丁名称在域名后",
  select_logo_and_store_product_image: "选择标志和商店/产品图片",
  select_logo: "选择标志",
  file_size_must_be_less_than_2mb: "文件大小必须小于2MB",
  for_buying_renewing_qr_click_expiry_button:
    "要购买/续订二维码，请点击到期日期按钮。",
  for_group_renewal_select_desired_qr_codes: "要批量续订，请选择所需的二维码。",
  no_qr_found_with_these_filters: "未找到符合这些过滤条件的二维码！",
  i_buy: "我购买",
  visits: "访问",
  creation_time: "创建时间",
  edit_time: "编辑时间",
  enter_business_card_name_correctly: "请正确输入名片名称！",
  are_you_sure_delete_qr: "您确定要删除二维码吗？",
  qr_deleted_successfully: "二维码已成功删除。",
  are_you_sure_deactivate_qr: "您确定要停用二维码吗？",
  are_you_sure_activate_qr: "您确定要875用二维码吗？",
  deactivated: "已停用",
  qr_successfully: "二维码成功",
  successfully: "成功",
  user_transferred_successfully: "用户已成功转移",
  problem_occurred_in_transfer: "转移中出现问题！",
  error_in_user_transfer: "用户转移错误！",
  qr_business_card_edited_successfully: "您的名片已成功编辑。",
  group_qr_renewal: "批量二维码续订",
  select_desired_duration: "选择所需时长",
  total_count: "总数",
  final_amount: "最终金额",
  ten_percent_vat_will_be_added: "将向上述金额添加10%增值税。",
  pay_and_upgrade: "支付并升级",
  no_tariff_for_this_period: "此期间无资费！",
  selected: "已选",
  total_amount: "总金额",
  final_amount_with_discount: "折扣后最终金额",
  add_qr: "添加二维码",
  actions: "操作",
  filter_type: "类型过滤",
  start_from: "从...开始",
  search_in_id: "在ID中搜索",
  filter_user: "用户过滤",
  clear_filters: "清除过滤",
  send_sms: "发送短信",
  selected_pattern: "已选模式",
  send: "发送",
  bulk_download: "批量下载",
  one_month_renewal: "一个月续订",
  three_month_renewal: "三个月续订",
  six_month_renewal: "六个月续订",
  one_year_renewal: "一年续订",
  no_item_selected: "未选择项目！",
  error_loading_card_info: "加载卡信息错误！",
  send_registered_successfully: "发送已成功注册",
  error_getting_prices: "获取价格错误！",
  payment_error: "支付错误！",
  business_card: "名片",
  product_label: "产品标签",
  restaurant_menu: "餐厅菜单",
  event_ticket: "活动门票",
  brochure: "宣传册",
  flyer: "传单",
  poster: "海报",
  catalog: "目录",
  newsletter: "通讯",
  organization_name_hint: "输入您的组织名称。",
  organization_name_label: "组织名称",
  sub_organization_hint: "输入子组织名称。",
  sub_organization_label: "子组织描述",
  user_name_hint: "输入您的姓名。",
  user_name_label: "姓名",
  work_field_hint: "输入您的职位。",
  work_field_label: "职位",
  mobile_number_hint: "输入您的号码。",
  mobile_number_label: "手机号码",
  phone_number_hint: "输入电话号码。",
  phone_number_label: "电话号码",
  email_hint: "输入您的电子邮件。",
  email_label: "电子邮件",
  fax_hint: "输入公司传真。",
  fax_label: "公司传真",
  website_hint: "输入公司网站。",
  website_label: "公司网站",
  postal_code_hint: "输入邮政编码。",
  postal_code_label: "邮政编码",
  copyright_hint: "输入页脚版权文本。",
  copyright_label: "版权文本",
  address_hint: "输入您的地址。",
  address_label: "地址",
  add_more_info: "添加更多您想要的信息：",
  edit_location: "编辑",
  add_location: "添加",
  delete_location: "删除位置",
  about_us_label: "关于我们",
  search_address: "搜索地址：",
  northern_coordinates: "北纬坐标",
  eastern_coordinates: "东经坐标",
  select_address_on_map: "在地图上选择地址",
  location_not_found: "未找到位置。",
  text_label: "文本",
  number_label: "数字",
  website_address_label: "网站地址",
  location_label: "位置",
  mobile_viewer_title: "移动查看器",
  visit_theme_two_title: "名片主题2",
  visit_theme_flipped_title: "翻转名片主题",
  flip_card: "翻转卡片",
  flip_card_description: "要查看更多信息，请翻转卡片",
  share_contacts: "分享联系人",
  close_share: "关闭分享",
  card_front: "卡片正面",
  card_back: "卡片背面",
  flip_to_back: "翻到背面",
  flip_to_front: "翻到正面",
  swipe_to_flip: "滑动翻转",
  swipe_left: "向左滑动",
  swipe_right: "向右滑动",
  expand_card: "展开卡片",
  contract_card: "收起卡片",
  view_details: "查看详情",
  hide_details: "隐藏详情",
  social_media_share: "社交媒体分享",
  contact_actions: "联系操作",
  card_actions: "卡片操作",
  floating_menu: "浮动菜单",
  close_menu: "关闭菜单",
  open_menu: "打开菜单",
  choice_gallery: "已选库",
  choice_video: "选择视频",
  url_video: "视频链接",
  selected_video: "已选视频",
  add_video: "添加视频",
  edit_video: "编辑视频",
  linl_video: "发布链接",
  upload_video: "上传视频",
  rule_link: "域名必须是 https://terminalads.com 或 terminalads.com。",
  fax_hint: "输入公司传真。",
  fax_label: "公司传真",
  website_hint: "输入公司网站。",
  website_label: "公司网站",
  postal_code_hint: "输入邮政编码。",
  postal_code_label: "邮政编码",
  add_more_info: "添加更多您想要的信息：",
  address_hint: "输入您的地址。",
  address_label: "地址",
  edit_location: "编辑",
  add_location: "添加",
  delete_location: "删除位置",
  location_label: "位置",
  about_company_label: "关于公司",
  select_address_on_map: "在地图上选择地址",
  search_address: "搜索地址：",
  rule_link: "域名必须是 https://terminalads.com 或 terminalads.com。",
  link_label: "链接地址",
  label_label: "标签",
  field_value_label: "字段值",
  add_new_field: "添加新字段",
  tehran_address: "德黑兰，沙里亚蒂街，赛义德·汉丹桥后，汉丹巷，6号",
  welcome_message_hint: "启用后，客户加入您的俱乐部时将发送欢迎消息。",
  change_pattern_campaign: "更改模板/活动",
  selected_message: "已选消息：",
  required_inputs: "必填字段：",
  selected_campaign_or_pattern: "已选活动/模板：",
  campaign: "活动",
  pattern: "模板",
  id: "ID",
  auto_csv_download_label: "自动保存",
  auto_csv_download_hint: "卡片打开时您的信息将自动下载到客户手机。",
  show_cclub_onload_label: "会员提议",
  show_cclub_onload_hint: "将打开加入客户俱乐部的窗口。",
  forced_submission_hint: "显示会员表单时，客户必须注册其号码。",
  forced_submission_forced: "强制会员",
  forced_submission_optional: "可选会员",
  has_manifest_icons_label: "网页应用设置",
  has_assistant_label: "助手标签",
  select_assistant: "选择助手",
  assistant_ai: "人工智能助手",
  has_manifest_icons_hint: "安装网页应用到手机或电脑时，将显示标志和图片。",
  logo_144px: "标志 144像素",
  logo_48px: "标志 48像素",
  photo_wide: "宽幅照片",
  photo: "照片",
  iranian_social_networks: "伊朗社交网络",
  foreign_social_networks: "外国社交网络",
  advertising_sites: "广告网站",
  other_links: "其他链接",
  custom_text: "自定义文本",
  custom_text_placeholder: "输入您的自定义文本。",
  aparat: "阿帕拉特",
  aparat_hint: "输入您的阿帕拉特频道名称",
  eitaa: "艾塔",
  eitaa_hint: "输入您的用户名",
  soroush: "苏鲁什",
  soroush_hint: "输入您的用户名",
  bale: "巴勒",
  bale_hint: "输入您的用户名",
  rubika: "鲁比卡",
  rubika_hint: "输入频道/群组链接",
  gap: "加普",
  gap_hint: "输入您的用户名",
  linkedin: "LinkedIn 个人主页",
  linkedin_hint: "输入您的用户名",
  linkedin_company: "LinkedIn 公司页面",
  linkedin_company_hint: "输入您的公司页面名称",
  pinterest: "拼趣",
  pinterest_hint: "输入您的用户名",
  dribbble: "德里布尔",
  dribbble_hint: "输入您的用户名",
  facebook: "脸书",
  facebook_hint: "输入您的用户名",
  github: "GitHub",
  github_hint: "输入您的用户名",
  threads: "线程",
  threads_hint: "输入您的用户名",
  tiktok: "抖音",
  tiktok_hint: "输入您的用户名",
  twitter: "推特",
  twitter_hint: "输入您的用户名",
  skype: "Skype",
  skype_hint: "输入您的用户名",
  youtube: "优兔",
  youtube_hint: "不带@输入您的用户名",
  wechat: "微信",
  wechat_hint: "输入您的用户名",
  viber: "Viber",
  viber_hint: "输入您的用户名",
  divar: "迪瓦尔",
  divar_hint: "输入广告/看板/商店链接",
  sheypoor: "谢普尔",
  sheypoor_hint: "输入广告/看板/商店链接",
  social_network: "社交网络",
  photo_logo_tab: "图片/标志",
  gallery_image_tab: "图片库",
  template_image: "模板图片",
  background_image: "背景图片",
  upload_logo: "上传标志",
  welcome_image_upload: "上传欢迎图片/标志",
  welcome_photo: "欢迎照片",
  loading_animation: "加载动画",
  preview_welcome_page: "预览欢迎页面",
  default_template_image: "默认模板背景图片",
  default_background_image: "默认背景图片",
  default_logo: "默认标志",
  default_welcome: "默认欢迎",
  default_gallery: "默认库",
  animation_scale: "从中心缩放",
  animation_slide_x: "从左滑动",
  animation_slide_y: "从上滑动",
  animation_fade: "淡入淡出",
  image_size_error: "最大背景图片大小：2MB。",
  logo_size_error: "最大标志大小：2MB。",
  categories: {
    bankcard: '银行卡',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "文本",
    multi_card: "多功能卡",
    product_introduction_pro: "产品介绍 Pro",
    electronic_business_card_pro: "专业电子名片",
    link_pro:"Link Pro",
    generated_images: "生成的图片",
    electronic_business_card: "电子名片",
    social_media: "社交媒体",
    photo_gallery: "图片库",
    video_gallery: "视频库",
    link: "链接",
    audio_gallery: "音频库",
    audio_gallery_pro: "音频库（专业版）",
    feedback: "反馈",
    consultation_form: "咨询表单",
    application: "应用",
    pdf_gallery: "PDF库",
    schedule_table: "时间表",
    personal_company_website: "个人/公司网站",
    online_store: "在线商店",
    online_menu: "在线菜单",
    appointment_booking: "预约",
    commercial_admin_website: "商业/管理网站",
    online_insurance_sales: "在线保险销售",
    discount_code: "折扣码",
    product_introduction: "产品介绍",
    product_label: "产品标签",
    gold_label: "黄金标签",
    franchise: "加盟（商业页面）",
    marketplace: "市场（商业页面）",
    recruitment_form: "招聘表单",
    organizational_form: "组织表单",
    employee_card: "员工卡",
    book_magazine: "书籍/杂志",
    catalog_brochure: "目录/宣传册",
    catalog: "目录",
    faq: "常见问题",
    feedback_survey: "反馈/调查",
    consultation_request: "咨询请求",
    customer_club: "客户俱乐部",
    invitation_card: "邀请卡",
    countdown: "倒计时",
    tombstone: "墓碑",
  },
  support_day60: "60天退款保证",
  "enter_visit_card_pro_info": "请输入 Pro 名片名称",
  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "编辑二维码文本",
       SERVER_DOWN: "系统更新中",
    CREATE_MEMORIES_MODEL: "创建回忆相框模型",
    CREATE_CARD_VISIT_PRO_MODEL: "创建专业名片模型",
    CREATE_PRODUCT_PRO_MODEL: "创建专业产品介绍模型",
    CREATE_PRODUCT_LABEL_MODEL: "创建产品标签模型",
    CREATE_PHOTO_GALLERY_MODEL: "创建图片画廊模型",
    CREATE_PDF_GALLERY_MODEL: "创建PDF画廊模型",
    CREATE_SOCIAL_MEDIA_MODEL: "创建社交媒体模型",
    EDIT_CARD_VISIT_PRO_MODEL: "编辑专业名片模型",
    EDIT_PRODUCT_PRO_MODEL: "编辑专业产品介绍模型",
    EDIT_PRODUCT_LABEL_MODEL: "编辑产品标签模型",
    EDIT_PHOTO_GALLERY_MODEL: "编辑图片画廊模型",
    EDIT_PDF_GALLERY_MODEL: "编辑PDF画廊模型",
    EDIT_SOCIAL_MEDIA_MODEL: "编辑社交媒体模型",
    BOOK: "手册 / 书籍",
    NFC_LIST: "NFC列表",
    API_KEY_MANAGER: "创建API密钥",
    PRE_PURCHASE: "预购",
    PRE_PURCHASE_MODEL: "现成模板",
    "QR_NAME_EDIT_GIFT": "编辑礼物二维码",
    "QR_GIFT": "礼物二维码",
      "QR_NAME_EDIT_PRO": "编辑 Pro 链接 QR 码",
        "QR_LINK_PRO": "QR Link Pro",
              DIGI: "Digikala价格监控",
      QR_PDF: "PDF图库",
      QR_NAME_EDIT_PDF: "编辑PDF图库",
      QR_MULTICART: "QR多卡",
      QR_MULTICART_EDIT: "编辑QR多卡",
      QR_NAME_PRODUCTPRO: "编辑产品专业版介绍",
      QR_PRODUCTPRO: "产品专业版介绍",
      QR_CATALOG: "目录 / 宣传册",
      QR_NAME_EDIT_CATALOG: "编辑目录",
      QR_LUCK_WHEEL_Edit: "编辑幸运转盘",
      QR_LUCK_WHEEL: "创建幸运转盘二维码",
      DASHBOARD: "仪表板",
      ADMIN_QR_DOMAINS: "域名监控",
      ADMIN_TOGETHER_TOKEN: "令牌监控",
      ADMIN_QR_SMS: "发送短信",
      MENU_PROFILE_INFO: "用户信息",
      MENU_PROFILE_SETTING: "个人资料设置",
      MENU_PROFILE_ORDERS: "订单",
      MENU_PROFILE_ADDRESSES: "地址",
      QR_MONITORING: "二维码监控",
      QR_LIST: "我的二维码列表",
      QR_NAME_LIST: "参与管理",
      QR_GENERATE_MULTIPLE: "批量二维码生成",
      QR_CARD_VISIT: "创建名片",
      HELP_INFO: "测试按钮",
      QR_MENU: "商店菜单",
      QR_APPOINTMENT: "预约",
      QR_INSURANCE: "创建在线保险",
      QR_BPAGE: "创建业务页面",
      QR_CPAGE: "创建商业/行政综合体网站",
      QR_BSHOP: "在线商店",
      QR_NAME_EDIT_BSHOP: "编辑在线商店",
      QR_LINK_EDIT: "编辑链接",
      QR_NAME_DESIGN: "编辑设计",
      QR_NAME_SETTING: "编辑设置",
      QR_NAME_EDIT: "编辑名片",
      QR_NAME_EDIT_BPAGE: "编辑业务页面",
      QR_EDIT_CPAGE: "编辑商业/行政综合体网站",
      QR_NAME_INSURANCE: "编辑在线保险",
      QR_NAME_EDIT_MENU: "编辑菜单",
      QR_NAME_EDIT_APPLICATION: "提供应用",
      QR_NAME_EDIT_APPOINTMENT: "编辑预约",
      QR_NAME_EDIT_PHOTO: "编辑照片图库",
      QR_NAME_EDIT_VIDEO: "编辑视频图库",
      QR_NAME_EDIT_VOICE: "编辑音频图库",
      QR_NAME_EDIT_FEEDBACK: "编辑反馈图库",
      QR_NAME_CONSULTATION_QR_EDIT: "编辑申请表单",
      QR_NAME_EDIT_VOICE_PRO: "编辑音频图库（专业版）",
      QR_NAME_EDIT_SOCIAL: "编辑社交网络",
      QR_NAME_STATISTICS: "二维码统计",
      QR_CATE: "选择类别",
      QR_SHARE: "分享",
      QR_BUSINESS_SHOP: "企业/商店",
      QR_CO_ORGAN: "公司/组织",
      QR_CONTACT: "客户联系",
      QR_NOTICES: "通知",
      QR_OTHERS: "其他",
      QR_STATICS: "静态二维码",
      QR_DYNAMICS: "动态二维码",
      QR_D_BUSINESS: "动态企业二维码",
      QR_D_ORGANS: "动态组织二维码",
      QR_D_GOVERNMENT: "动态政府二维码",
      QR_VIDEO: "视频图库",
      QR_APPLICATION: "提供应用",
      QR_VOICE: "音频图库",
      QR_VOICE_PRO: "音频图库（专业版）",
      QR_CONSULTATION_QR: "申请表单",
      QR_FEEDBACK: "反馈图库",
      QR_PHOTO: "照片图库",
      QR_LOCATION: "创建位置二维码",
      QR_SOCIAL_MEDIA: "创建社交媒体二维码",
      QR_LINK: "创建链接",
      QR_TEXT: "创建文本",
      QR_MAIL: "创建电子邮件",
      QR_CALL: "呼叫",
      QR_SMS: "短信",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "网站",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "业务页面",
      QR_DISCOUNT: "折扣页面",
      QR_PRODUCT_SHOP: "产品介绍",
      QR_PRODUCT_LABEL: "产品标签",
      QR_GOLD_LABEL: "黄金标签",
      QR_PRODUCT_TEMPLATE: "产品",
      ADMIN_CATEGORY: "类别",
      QR_NFC_ORDERS: "等待确认的NFC卡",
      QR_NAME_PRODUCT: "编辑产品介绍",
      QR_NAME_LABELPRODUCT: "编辑产品标签",
      QR_NAME_GOLDPRODUCT: "编辑黄金标签",
      QR_COINS: "加密货币",
      QR_SHOP: "商店管理",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "上传中心",
      PRICING: "二维码资费",
      QR_CREATE_MODELS: "创建名片模型",
      QR_CREATE_BUSINESS_MODELS: "创建业务页面模型",
      QR_CREATE_PRODUCT_MODEL: "创建产品卡模型",
      QR_CREATE_MENU_MODELS: "创建商店菜单模型",
      QR_CREATE_SHOP_MODEL: "创建在线商店模型",
      MODELS_LIST: "二维码模型类型",
      MODELS_LIST_EDIT: "编辑模型",
      MODELS_LIST_MENU_EDIT: "编辑菜单模型",
      MODELS_LIST_BMODEL_EDIT: "编辑在线商店模型",
      NFC: "NFC卡",
      SUBMIT_FORM: "注册博主",
      REQUEST_LIST: "博主列表",
      PURE_DATA: "未创建名片列表",
      AUTO_CREATE: "自动二维码创建",
      QR_CREATE: "创建二维码",
      HISTORY_REMINDER: "提醒监控",
      BOOK: "提醒监控"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "支付方式",
      ORDER_NOTIFICATIONS: "订单通知",
      DISCOUNT_CODE: "折扣码",
      CART: "购物车",
      TABLE_MANAGEMENT: "桌台管理",
    },
    ERRORS: {
      INVALID_INPUT: "请输入正确的值！",
      CART_SETTINGS_FAILED: "购物车设置失败！",
    },
  },
  popup: {
    prepared_stores_title: "准备好的在线商店示例",
  },
  buttons: {
    reset_defaults: "重置默认数据",
    download_qr: "下载二维码",
    cleardefaults: "清除默认信息",
    select_prepared_store: "选择准备好的在线商店",
  },
  stepper: {
    create_qr: "创建二维码",
    products_info: "产品和信息",
    content_settings: "内容设置",
    sales_settings: "销售设置",
  },
  fields: {
    online_store_name: "在线商店名称",
    qr_address: "二维码地址",
    qr_address_hint: "输入您的二维码地址",
    online_sale: "在线销售",
  },
  login_settings: "登录设置",
  shop_logo_and_images: "商店标志和图片",
  login_page_info: "登录页面信息",
  upload_banner: "上传横幅",
  create_product: "创建产品",
  special_sale: "特价销售",
  ended: "已结束",
  blog: "博客",
  services: "服务",
  pdf_gallery: "PDF图库",
  create_section: "创建部分",
  achievements: "成就",
  team_members: "团队成员",
  working_hours: "工作时间",
  saturday: "星期六",
  sunday: "星期日",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  we_will_be_different: "我们会与众不同……",
  striving_for_excellence: "我们始终追求卓越 >>> 为您",
  online_store_ready_15_minutes: "您的在线商店15分钟内准备就绪！",
  sales_management: "销售管理",
  dear_customer_online_stores: "亲爱的客户，您也可以在我们其他在线商店购物：",
  divar_site: "Divar网站",
  digikala_site: "Digikala网站",
  basalam_site: "Basalam网站",
  torob_site: "Torob网站",
  emalls_site: "Emalls网站",
  copyright_qrland: "QR Land保留所有权利。",
  tehran_address: "德黑兰，沙里亚蒂街，赛义德·汉丹桥后，汉丹巷6号",
  our_achievements: "我们的成就",
  customer_satisfaction: "客户满意度",
  lowest_returns: "最低退货率",
  loyal_customer: "忠实客户",
  shipped_orders: "已发货订单",
  visit_our_videos: "访问我们的视频。",
  bringing_the_best: "我们为您带来了最好的……",
  feedback_important: "您的反馈对我们很重要",
  guide_us_with_feedback: "请通过回答以下问题指导我们提供更好的服务。",
  satisfied_with_quality: "您对商品质量满意吗？",
  evaluate_packaging_quality: "您如何评价包装质量？",
  satisfied_with_variety: "您对商品多样性满意吗？",
  benefited_from_discounts: "您是否从本店折扣中受益？",
  post_1: "帖子1",
  fast_order_delivery: "快速订单交付",
  post_2: "帖子2",
  post_3: "帖子3",
  product_authenticity_guarantee: "产品正品保证",
  comfortable_purchase: "舒适购物",
  how_to_place_order: "如何下订单？",
  add_to_cart: "只需将所需产品添加到购物车。",
  how_to_register: "如何在网站注册？",
  click_login_and_enter_code:
    "只需点击“登录”按钮，输入手机号码后输入收到的短信验证码。",
  delivery_time: "注册后订单到达需要多久？",
  fastest_delivery: "您的订单将尽快发货。",
  shipping_cost: "运费是多少？",
  shipping_cost_order: "订单运费",
  variable_shipping_cost: "运费因您的地址而异。",
  change_or_cancel_order: "注册后可以更改或取消订单吗？",
  no_change_or_cancel: "不可以。无法更改或取消。",
  mrs_Safdarian: "萨夫达里安女士",
  invalid_address: "输入的地址无效！",
  shop_page_created_success: "您的商店页面已成功创建。",
  qr_creation_failed: "二维码创建失败！",
  server_error: "服务器错误！",
  qr_card_updated_success: "您的名片已成功编辑。",
  qr_save_edit_failed: "保存/编辑二维码时出错",
  your_feedback: "您的反馈",
  digital_marketing_strategy: "用我们的数字营销策略师将您的公司引向正确轨道",
  wait_for_default_products: "请等待默认产品完全加载到您的网站。",
  template_categories_saved: "模板类别已成功保存。",
  template_products_saved: "模板产品已成功保存。",
  template_products_save_failed: "保存模板产品时出错！",
  template_categories_save_failed: "保存模板类别时出错！",
  login_page_text: "登录页面文本",
  persian_error: "文本必须是波斯语",
  number_error: "输入数据不得为非数字或为空",
  english_error: "文本不得为非英语或为空",
  mixPerEng_error: "文本不得为非英语或非波斯语或为空",
  email_error: "输入的电子邮件格式无效",
  mobile_error: "输入的号码格式无效",
  meliCode_error: "输入的国家代码格式无效",
  site_error: "输入的网站格式无效",
  min_length_error: "输入值不得小于{{min}}",
  max_length_error: "输入值不得大于{{max}}",
  form_submitted_message: "您的表单已成功提交",
  required_fields_error: "未输入必填值",
  headphone_title: "耳机",
  buy_button: "购买",
  day: "天",
  hour: "小时",
  minute: "分钟",
  second: "秒",
  required_field_error: "{{fieldName}}为必填项",
  submit_request_button: "提交请求",
  request_submitted_success: "您的请求已成功注册",
  feedback_submitted_success: "您的反馈已成功注册",
  description_required_label: "描述（必填）",
  description_optional_label: "描述（可选）",
  description_hint: "请在此字段输入您想要的描述（至少3个字符）",
  footer: {
    position: "侧边",
    contactUs: "联系我们",
    aboutUs: "关于我们",
    firstShift: "第一班",
    secondShift: "第二班",
    startTime: "开始时间",
    endTime: "结束时间",
    features: "功能",
    partners: "合作伙伴",
    affiliates: "联盟计划",
    panels: "面板",
    supportTicket: "支持工单",
    inPersonServices: "面对面服务",
    liveChat: "在线聊天",
    faq: "常见问题",
    add_secondshift: "添加第二班",
    firstDate: "开始日期",
    endDate: "结束日期",
  },
  qr_management: "二维码管理",
  restore_default_questions: "恢复默认问题",
  delete_all: "全部删除",
  edit_question: "编辑问题",
  move_up: "上移",
  move_down: "下移",
  delete: "删除",
  selected_question: "选中的问题",
  question: "问题",
  answer_type: "答案类型",
  excellent: "优秀",
  good: "良好",
  very_poor: "很差",
  response_optionality: "可选 / 必填回答",
  required: "必填",
  optional: "可选",
  add_new_question: "添加新问题",
  satisfied_with_quality: "您对商品质量满意吗？",
  evaluate_packaging_quality: "您如何评价包装质量？",
  satisfied_with_variety: "您对商品多样性满意吗？",
  benefited_from_discounts: "您是否从本店折扣中受益？",
  suggestions_for_improvement: "您对改善本店购物体验有什么建议？",
  confirm_delete_question: "删除选中的问题？",
  question_deleted_success: "问题已成功删除。",
  question_delete_failed: "删除问题时出错！",
  confirm_delete_all_questions: "您确定要删除所有问题吗？",
  questions_deleted_success: "问题已成功删除。",
  questions_delete_failed: "删除问题时出错！",
  invalid_input: "请输入正确的值！",
  operation_failed: "操作失败！",
  question_number: "问题{number}？",
  card_subtitle: "只需输入您想要的图片的故事，AI将为您创建。",
  upgrade_label: "附加",
  free: " - 免费",
  language_select: "选择用于编写请求文本的语言",
  image_size: "图片大小",
  prompt_label: "请求文本",
  prompt_placeholder: "描述您想要的图片……",
  generate_image: "生成图片",
  regenerate_image: "生成新图片",
  save_image: "保存图片",
  save_image_subtitle: "仅保存上方显示的图片。",
  size_items: {
    "16:9": "16:9（横向）",
    "9:16": "9:16（纵向）",
    "1:1": "1:1（方形）",
  },
  lang_items: {
    fa: "Fa | 波斯语",
    en: "En | 英语",
    ar: "Ar | 阿拉伯语",
  },
  rules: {
    empty: "至少输入3个字符！",
    spell_checker: "输入的文本必须是{language}语言！",
  },
  ERRORS: {
    VpnDetectedTitle: "请关闭VPN",
    VpnDetectedSubtitle: "这有助于系统更好地运行并为您提供更好的体验。",
  },
  errors: {
    VpnDetectedTitle: "请关闭VPN",
    VpnDetectedSubtitle: "这有助于系统更好地运行并为您提供更好的体验。",
    invalid_size: "请正确输入宽度和高度！",
    image_generation_error: "图片生成错误",
    image_upload_error: "图片上传错误！",
    service_unavailable: "无法使用此服务 - 从服务器加载数据时出错",
    qr_address_taken: "该QR地址已被占用",
  },
  add_working_time: "添加工作时间",
  selected_day: "选中的日子",
  range_name: "时间范围名称",
  add: "添加",
  first_shift: "第一班",
  second_shift: "第二班",
  start_time: "开始时间",
  end_time: "结束时间",
  date_range: "日期范围",
  all_week_days: "一周的所有日子",
  saturday_to_wednesday: "星期六至星期三",
  saturday_to_thursday: "星期六至星期四",
  work_week: "一周的所有日子（节假日除外）",
  feedbacks: "反馈",
  failed_retrieve_feedback: "获取反馈失败！",
  province: "省份",
  search_city_placeholder: "搜索您想要的城市名称。",
  search_city_label: "城市搜索",
  welcome: "欢迎使用我们的应用",
  description: "这是一个多语言应用。",
  soon: "即将推出",
  beta_version: "测试版",
  defaults_cleared_success: "默认数据已成功清除",
  defaults_reset_success: "默认数据已成功重置",
  select_navigator_after_location_click: "点击位置后，选择所需的导航器",
  no_address_selected: "未选择地址",
  no_location_selected: "未选择位置",
  region: "地区",
  api_unauthorized: "认证错误：无效的API密钥",
  location_not_found: "位置未找到",
  addCategory: "添加新类别",
  editCategory: "编辑类别",
  deleteCategory: "删除选定的类别？",
  addProduct: "添加新产品",
  saveProducts: "选择默认产品",
  addSubCategory: "添加子类别",
  product: "产品",
  categoryName: "类别名称",
  subCategoryName: "子类别名称",
  confirmDeleteProduct: "是否从类别中移除产品？",
  successMessages: {
    categorySaved: "类别保存成功。",
    productSaved: "产品保存成功。",
    productDeleted: "产品删除成功。",
  },
  errorMessages: {
    saveCategoryFailed: "保存类别出错！",
    saveProductFailed: "保存产品出错！",
    deleteCategoryFailed: "删除类别出错！",
  },
  add_edit_categories: "添加/编辑类别",
  copy_category: "复制类别",
  product: "产品 {point}",
  copy_product: "复制产品",
  add_edit_products: "添加/编辑产品",
  edit_category: "编辑类别",
  category_name: "类别名称",
  edit_subcategory: "编辑子类别",
  subcategory_name: "子类别名称",
  add_new_category: "添加新类别",
  store_management: "商店管理",
  manage_products: "产品管理",
  products_export: "下载产品",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "上传Excel文件",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "将您的Excel文件拖到这里或",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "选择它",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "以上传",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE": "请仅上传Excel文件（.xlsx）",
  "GENERAL.SUBMIT": "提交",
  "GENERAL.CANCEL": "取消",
  "GENERAL.SUCCESSFULLY_ADDED": "产品上传成功",
  SUCCESSFULLY_DOWNLOADED: "产品下载成功",
  "GENERAL.ERROR": "发生错误",
  EditSubCategoty: "编辑子类别",
  create: "创建",
  save_changes: "保存更改",
  buy_button_settings: "购买按钮设置",
  image: "图片",
  color: "颜色",
  title: "标题",
  price: "价格",
  discount: "折扣",
  percent: "百分比",
  amount: "金额",
  brand: "品牌",
  inventory: "库存",
  inventory_hint: "留空 = 无限订单数量",
  order_limit: "每订单最大数量",
  order_limit_hint: "留空 = 无限制",
  packing_price: "包装费用",
  packing_price_hint: "适用于外部订单（快递/现场取货）。",
  description: "描述",
  options: "选项",
  product_features: "产品特征",
  field_required: "必填字段。",
  min_length: "至少需要3个字符。",
  product: "产品",
  default_brand: "苹果",
  product_added_success: "产品添加成功",
  product_added_error: "添加产品出错",
  whole_categories: "(所有类别)",
  add_select_category: "添加/选择类别",
  select_default_category: "选择默认类别",
  deleted_product: "删除产品",
  confirm_delete_prooduct: "是否从类别中移除产品？",
  please_wait_store_product: "产品正在保存，请等待...",
  saved_product_success: "产品保存成功。",
  error_in_store: "保存出错",
  delete_category: "删除类别",
  confirm_delete_category: "类别删除成功。",
  error_delete_category: "删除类别出错！",
  productOptionEditor: {
    tabs: {
      color: "颜色",
      size: "尺寸",
      count: "数量",
      weight: "重量",
      type: "类型/性别",
    },
    fields: {
      count: "数量",
      max_order: "最大订单数量",
      price: "价格",
      discount: "折扣",
      color: "颜色",
      color_name: "颜色名称",
      inventory: "库存",
      size: "尺寸",
      type: "类型/性别",
      weight: "重量",
    },
    actions: {
      delete: "删除",
      add_location: "添加选项",
    },
  },
  extraSubProducts: {
    feature: "特征",
    name_label: "名称",
    name_placeholder: "示例：额外酱料 / 额外面包",
    price_label: "价格",
    price_hint: "留空 = 免费附加。",
    price_placeholder: "示例：水，类型（例如鸡胸肉/鸡腿）",
    add_subproduct: "添加附加产品",
  },
  error_selected_category: "选择类别出错！",
  suggestinput: {
    title: "选择表情符号",
    aboutUs: "关于我们",
    error: "错误",
    errorMessage: "请充值信用额并重试。",
    generateText: "AI文本建议",
    emoji: "表情符号",
    errorMessage_400: "创建'关于我们'文本出错。请重试。",
    errorMessage_403: "创建'关于我们'文本出错。请购买套餐并重试。",
  },
  togetherai: {
    buy_package: "购买套餐",
    tax_notice: "套餐价格将添加10%增值税！",
    package: "套餐",
    rial: "里亚尔",
    buy_button: "购买！",
    discount_label: "折扣码",
    submit_discount: "兑换",
    success_message: "您的QR已成功升级。",
    error_insufficient_funds: "检查您的信用额并稍后重试。",
    error_upgrade: "升级QR出错！",
    error_title: "错误",
    success_title: "成功",
  },
  category_not_found: "类别未找到！",
  create_upload_category: "创建并上传类别",
  add_subcategory: "添加子类别",
  error_upload_m_video: "上传视频出错（可能访问受限）。",
  info_show_video: "点击'更多'显示更多。",
  error_not_valid_guide_id: "无效的指南ID！",
  error_give_guide_info: "获取指南信息出错！",
  info_success_saved: "保存成功",
  error_add_new_guide: "添加新指南出错",
  popup: {
    details: "详情",
    guide_images: "指南图片",
    guide_videos: "指南视频",
    faq: "常见问题",
    no_title: "无标题",
    no_content: "无内容显示",
    no_questions: "无问题显示",
    video_error: "上传视频出错（可能访问受限）",
    no_answer: "无答案",
    question_no_title: "无标题问题",
    default_title: "指南",
  },
  productPicker: {
    select_default_product: "选择默认产品",
    search: "搜索",
    select_all_products: "选择所有产品",
    back: "返回",
    no_products_in_category: "此类别中无产品！",
    products_error: "加载产品出错！",
    retry: "重试",
    items_per_page: "每页项目",
    root_breadcrumb: "/",
  },
  end_date: "结束日期",
  filters: {
    userType: {
      legal: "法人实体",
      individual: "个人",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "广告牌",
      tablighNegar: "TablighNegar",
      unknown: "未知",
    },
    qrType: {
      attendanceqr: "考勤管理",
      gift: "回忆相框",
      instagram: "Instagram",
      visitCard: "电子名片",
      Business: "个人 / 企业",
      Commericial: "商业 / 办公综合体网站",
      qrlink: "二维码链接",
      labelproduct: "产品标签",
      goldLabel: "黄金标签",
      bShop: "商店",
      SocialMedia: "社交媒体",
      VideoGallery: "视频图库",
      PhotoGallery: "照片图库",
      voiceGallery: "音频图库",
      consultationQr: "申请表单",
      application: "应用程序",
      feedbackGallery: "用户反馈",
      voiceGalleryPro: "专业音频图库",
      singleProduct: "产品介绍",
      menu: "菜单",
      appointment: "预约",
      insurance: "保险",
      text: "文本",
      luck_wheel: "幸运转盘",
      pdfgallery: "PDF图库",
      productpro: "Pro产品介绍",
      multicard: "多卡片",
      catalog: "目录",
      visitCard_pro: "Pro电子名片",
      clickyarseo: "ClickYar SEO二维码",
    },
    expire: {
      day: "天",
      expired: "已过期",
    },
    numericPersianNumber: {
      thousand: "千",
      million: "百万",
    },
    dateString: {
      at: "在",
    },
    messages: {
      pleaseLogin: "请登录",
      invalidPhone: "无效电话号码",
      copied: "已复制",
    },
  },
  nextButton: "下一个",
  previousButton: "上一个",
  rowsPerPageText: "每页行数",
  noDataText: "无数据显示",
  placeholderSearch: "搜索..",
  set_qr: "QR已注册",
  numbers: "数字",
  enter_param_product: "正确输入产品数据！",
  instagram_hint: "输入您的Instagram",
  whatsapp_hint: "输入您的WhatsApp",
  telegram: "Telegram",
  telegram_hint: "输入您的Telegram",
  userpicker: {
    select_user: "选择用户",
    choice_users: "选择用户",
    id: "ID",
    phone_number: "手机号码",
    date_created: "创建日期",
    info_edit: "编辑信息",
    name_family: "姓名",
    position: "职位和级别",
    phone: "电话",
    discription: "描述",
  },
  search_product: "搜索产品",
  search_name_product: "搜索产品名称",
  currency: "里亚尔",
  headers: {
    index: "顺序",
    gallery: "图片",
    id: "ID",
    name: "名称",
    brand: "品牌",
    price: "金额",
    discount_amount: "折扣",
  },
  search_categories: "在类别中搜索",
  delete_all: "删除全部",
  select_category: "选择类别",
  currency1: "伊朗里亚尔",
  features: "特征",
  product_sp: {
    edit: "编辑",
    back: "返回",
    save: "保存",
    add_product_to_special_category: "填写字段以将产品添加到特殊类别",
    inventory: "库存",
    discount: "折扣",
    max_per_customer: "每客户最大",
    max_per_order: "每订单最大",
    expires_at: "到期日期",
    field_cannot_be_empty: "字段不能为空。",
    please_enter_correctly: "请正确填写！",
    currency: "伊朗里亚尔",
  },
  selectproduct: "选择产品",
  section: {
    edit_part: "编辑部分",
    title: "标题",
    position_text: "文本位置",
    add_video: "添加视频",
    text: "文本",
    address_video: "视频URL",
    position_left: "左侧",
    position_right: "右侧",
    tab_edit_button: "编辑按钮",
    tab_content: "部分内容",
  },
  name_shopping: "商店名称",
  hint_shopping: "输入您的商店名称。",
  title_discount: "折扣标题",
  hint_discount: "输入您的折扣标题。",
  hint_mount_discount: "下次订单20%折扣。",
  label_discount: "输入折扣金额",
  give_discount: "获取折扣码",
  give_copon: "获取优惠券",
  enter_copon: "输入优惠券",
  hint_phone: "输入您的电话号码。",
  label_phone: "电话号码",
  hint_condition_discount: "描述折扣条件..",
  label_discription_discount: "折扣描述",
  add_info_discount: "添加额外信息：",
  enter_address_discount: "输入您的地址。",
  address_discount: "地址",
  edit_feedback: "编辑反馈",
  select_type_replay: "选择回复类型",
  field_discription: "描述字段",
  messages_discription: "启用以向用户显示描述字段",
  number_char: "字符数必须在3到50之间！",
  search: "搜索",
  no_videos_found: "未找到视频！",
  upload_video_prompt: "使用视频上传区域添加文件",
  delete_success: "删除成功。",
  tabs: {
    qr_view: "QR视图",
    preview: "预览",
    ready_video: "准备好的视频",
    video_gallery: "视频画廊",
    link: "链接",
    video_upload: "上传视频",
  },
  consultation: {
    name: "名字",
    surname: "姓氏",
    phone: "手机号码",
    nationalId: "国家ID号码",
    nationalIdAuthenticate: "验证国家ID",
    nationalIdCorrect: "检查国家ID号码有效性",
    mail: "电子邮件",
    address: "地址",
    location: "位置",
    custom: "自定义",
    customLabel: "标题",
    customOptions: "选项",
    optional: "可选",
    require: "必填",
    description: "描述",
  },
  add_section: "添加部分",
  add_new_text_section: "您被热烈邀请到QR-Land的智能数字世界。",
  btn_title_section: "免费注册",
  shop: {
    step_products_and_info: "产品与信息",
    online_store_name: "在线商店名称",
    qr_address: "QR地址",
    qr_address_hint: "输入您的QR地址",
    online_sale: "在线销售",
    step_content_settings: "内容设置",
    step_sale_settings: "销售设置",
    download_qr: "下载QR",
    login_settings: "登录设置",
    store_logo_images: "商店标志和图片",
    login_page_info: "登录页面信息",
    upload_banner: "上传横幅",
    user_info: "用户信息",
    create_product: "创建产品",
    special_sale: "特价销售",
    add_social_media: "添加社交媒体",
    blog: "博客",
    services: "服务",
    faq: "常见问题",
    photo_gallery: "照片画廊",
    video_gallery: "视频画廊",
    pdf_gallery: "PDF画廊",
    feedback: "反馈",
    countdown: "倒计时",
    request_form: "请求表单",
    create_section: "创建部分",
    achievements: "成就",
    team_members: "团队成员",
    working_hours: "营业时间",
    error_saving_content: "保存内容设置出错！",
    success_edit_store: "商店页面编辑成功。",
    post_1: "帖子1",
    logo: "标志",
    background_image: "背景图片",
  },
  discount_obj: {
    quantity: "数量",
    create_edit_code: "创建/编辑折扣码",
    coding_type_label: "创建类型",
    coding_type_single: "单个",
    coding_type_group: "组",
    status_label: "状态",
    status_active: "活跃",
    status_deactivate: "已停用",
    discount_code: "折扣码",
    discount_type: "折扣类型",
    discount_type_percent: "百分比",
    discount_type_fixed: "固定金额",
    discount_value: "折扣值",
    discount_limit: "折扣限制",
    no_limit: "无限制",
    tab_create_discount: "创建折扣码",
    tab_settings: "设置",
    success_create: "折扣码创建成功",
    success_edit: "折扣码编辑成功",
    error_value_empty: "折扣值不能为空！",
    error_start_time: "未选择开始时间！",
    error_end_time: "未选择结束时间！",
    error_same_time: "开始和结束时间不能相同",
  },
  personnel: {
    team_members: "选定的团队成员",
    add_team_member: "添加团队成员",
    default_position: "职位和级别",
    default_phone: "电话号码",
    default_full_name: "全名",
    default_description: "Lorem Ipsum只是印刷行业的虚拟文本，设计师使用数百年",
  },
  discount_settings: {
    function_type: {
      title: "折扣功能",
      all_shopping_cart: "购物车总金额",
      special_products: "特殊产品",
      special_categories: "特殊类别",
    },
    basket_condition: {
      title: "购物车条件",
      no_conditions: "无条件",
      minimum_shopping: "最小购物车金额",
      minimum_product: "购物车最小产品数",
      maximum_shopping: "最大购物车金额",
      maximum_product: "购物车最大产品数",
    },
    user_settings: {
      title: "用户设置",
      all_user: "所有用户",
      group: "用户组",
      special: "特殊用户",
    },
    limitation_use: {
      title: "使用限制",
      no_limitations: "无限制",
      discount_code: "折扣码使用次数",
      user: "每用户使用次数",
    },
    start_time: {
      title: "折扣开始日期",
      no_time_selected: "未选择开始时间",
    },
    end_time: {
      title: "折扣结束日期",
      no_time_selected: "未选择结束时间",
    },
  },
  counterService: {
    typeLabel: "显示类型",
    number: "数字",
    percent: "百分比",
    iconLabel: "图标",
    counterLabel: "值",
    linkLabel: "链接",
    nameLabel: "标题",
    addButton: "添加成功",
    successful: {
      added: "项目添加成功",
      removed: "项目移除成功",
      movedUp: "项目上移成功",
      movedDown: "项目下移成功",
    },
  },
  qrUsersList: {
    customersList: "客户列表",
    orders: "订单",
    addresses: "地址",
    hasAssistantsMobile_hint: "选择手机",
    invalidPhone: "输入的手机号码无效",
    validation: {
      nameRequired: "姓名必填",
      nameMinLength: "姓名至少需要2个字符",
      familyRequired: "姓氏必填",
      familyMinLength: "姓氏至少需要2个字符",
    },
    addUser: "添加用户",
    registerOnline: "启用在线注册",
    usersColumns: {
      id: "ID",
      name: "名字",
      family: "姓氏",
      mobile: "手机",
      subscriptionId: "订阅ID",
      ordersCount: "订单数",
      lastLogin: "最后登录",
      status: "状态",
      activeUser: "活跃用户",
      none: "-",
      actions: "操作",
      buttons: {
        info: "客户数据",
        sendSms: "发送短信",
        history: "历史",
        addresses: "地址",
        orders: "订单",
      },
    },
    orderColumns: {
      orderId: "订单号",
      customerName: "客户姓名",
      mobile: "手机",
      paymentMethod: "支付方式",
      shippingMethod: "配送方式",
      orderAmount: "订单金额",
      orderTime: "订单时间",
      status: "状态",
      currency: "里亚尔",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "地址标题",
      name: "名字",
      family: "姓氏",
      mobile: "电话",
      address: "地址",
      zipCode: "邮编",
      number: "门牌号",
      unit: "单元",
    },
    shippingType: {
      courier: "快递",
      reservation: "桌位预订",
      place: "现场取货",
      none: "-",
    },
    paymentType: {
      online: "在线支付",
    },
    perPage: "每页条目",
    search: "搜索",
    sortColumn: "排序列",
    sortDirection: "排序方向",
    sortDirectionDesc: "降序",
    sortDirectionAsc: "升序",
    noStatus: "未找到状态",
    status: {
      all: "全部",
      active: "活跃",
      inactive: "不活跃",
    },
    fetchError: "加载用户数据出错",
  },
  listCardHeader: {
    clear_filters: "清除过滤器",
    group_qr_renewal: "批量QR码续订",
    select_desired_duration: "选择所需时长",
    total_count: "总数",
    final_amount: "最终金额",
    ten_percent_vat_will_be_added: "将添加10%增值税",
    pay_and_upgrade: "支付并升级",
    no_tariff_for_this_period: "此期间无资费",
    one_month_renewal: "1个月续订",
    three_month_renewal: "3个月续订",
    six_month_renewal: "6个月续订",
    one_year_renewal: "1年续订",
    selected: "已选",
    view: "查看",
    details: "详情",
    total_amount: "总金额",
    discount: "折扣",
    final_amount_with_discount: "折扣后最终金额",
    add_qr: "添加QR",
    select_all: "全选",
    actions: "操作",
    filter: "过滤",
    type_filter: "类型过滤",
    start_from: "从...开始",
    search: "搜索",
    id_search: "ID搜索",
    filter_user: "用户过滤",
    sort: "排序",
    send_sms: "发送短信",
    selected_pattern: "选定模式：",
    send: "发送",
    newest: "最新",
    oldest: "最旧",
    most_visited: "最多访问",
    least_visited: "最少访问",
    pause: "暂停",
    bulk_download: "批量下载",
    activate: "激活",
    deactivate: "停用",
    error_loading_card: "加载卡片数据出错！",
    error_fetching_prices: "获取价格出错！",
    error_payment: "支付出错！",
    sms_success: "短信发送成功",
    generic_error: "发生错误！",
  },
  headerTypeFilter: {
    qr_model: "QR模型",
    all_qr_models: "所有QR模型",
  },
  menuOrderFactor: {
    order_invoice: "订单发票",
    total: "总计",
    tax: "税",
    shipping_cost: "运费",
    packing_cost: "包装费",
    discount: "折扣",
    final_total: "最终总计",
    currency: "里亚尔",
    titles: {
      default_title: "标准订单",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "在列表中搜索",
    search: "搜索",
    start_from: "从...开始",
  },
  headerStatusFilter: {
    all_qr_codes: "所有QR码",
    active_qr_codes: "活跃QR码",
    inactive_qr_codes: "不活跃QR码",
    expiring_qr_codes: "即将过期QR码",
    expired_qr_codes: "已过期QR码",
  },
  qrOrdersList: {
    title: "订单列表",
    orderColumns: {
      index: "订单",
      id: "订单号",
      customerName: "客户姓名",
      mobile: "手机",
      paymentType: "支付类型",
      shippingType: "配送类型",
      price: "订单金额",
      createdAt: "订单时间",
      status: "状态",
      actions: "操作",
    },
    productsColumns: {
      productId: "产品ID",
      image: "图片",
      productName: "产品名称",
      unitPrice: "单价",
      quantity: "数量",
      totalPrice: "总价",
    },
    actions: {
      products: "订单列表",
      print: "打印订单",
      share: "分享订单",
      status: "更改状态",
    },
    shippingType: {
      courier: "快递",
      reservation: "桌位预订",
      place: "现场取货",
      post: "邮寄",
      unknown: "-",
    },
    paymentType: {
      online: "在线支付",
      place: "现场支付",
      unknown: "-",
      card2card:"卡对卡支付",
    },
    status: {
      all: "全部",
      pending: "待支付",
      accepted: {
        place: "现场支付",
        paid: "已支付",
      },
      delivered: "已交付",
      rejected: "支付失败",
    },
    factorTitle: "订单发票",
    printFactor: "打印发票",
    fetchError: "加载数据出错",
    statusChanged: "状态更改成功",
    statusChangeError: "更改状态出错",
    currency: "里亚尔",
    perPage: "计数",
    search: "搜索",
    noStatus: "无状态",
    loading: "加载中...",
    noShippingType: "无配送类型",
    noPaymentType: "无支付类型",
    sortColumn: "排序列",
    sortDirection: "排序方向",
    sortDirectionDesc: "降序",
    sortDirectionAsc: "升序",
    selectNewStatus: "选择新状态",
    changeStatusTitle: "更改状态",
    linkCopied: "链接已复制。",
  },
  qrUserTransfer: {
    title: "所有权转移",
    radioLabels: {
      userTransfer: "转移给他人",
      givingAccess: "授予访问权",
    },
    inputLabels: {
      phone: "个人手机号码",
    },
    hints: {
      addNumber: "按Enter或+添加",
      addNumberStep2: "按Enter或+添加",
    },
    buttons: {
      transfer: "转移",
      giveAccess: "授予访问权",
      back: "返回",
      saveChanges: "保存更改",
      cancel: "取消",
        "add": "添加"

    },
    tooltips: {
      deleteAccess: "移除访问权",
    },
    subtitles: {
      accessList: "授权用户列表：",
      selectPermissions: "选择权限：",
    },
    permissionList: {
      edit_name: "编辑服务名称",
      edit_link: "编辑链接",
      edit_info: "编辑信息",
      edit_design: "编辑QR设计",
      edit_settings: "编辑QR设置",
      toggle_access: "启用/禁用访问",
      view_customers: "查看客户列表",
      view_orders: "查看订单列表",
    },
    messages: {
      invalidPhone: "无效电话号码",
      duplicatePhone: "不允许重复号码",
      updateAccessSuccess: "访问更新成功。",
      updateAccessError: "更新出错：{message}",
      deleteAccessSuccess: "访问移除成功。",
      deleteAccessError: "移除出错：{message}",
      fetchAccessError: "加载出错：{message}",
      transferSuccess: "QR转移成功。",
      transferError: "转移出错：{message}",
      giveAccessSuccess: "设置成功。",
      giveAccessError: "设置出错：{message}",
      confirmDeleteAccess: "真的移除此人的访问权吗？",
    },
  },
  form: {
    form_download: "接收的表单",
    form_add: "添加表单",
    formdownload: "接收的表单",
    create_at: "创建于：",
    shown: "显示",
    nogiveform: "您没有接收的表单",
    back: "返回",
    invalid_date: "无效日期",
    select_date: "选择日期",
    select: "选择",
    clear: "清除",
    now: "现在",
  },
  dsBasketCondition: {
    title: "最小购物车条件",
    items: {
      NoConditions: "无条件",
      MinimumShopping: "最小购物车金额",
      MinimumProduct: "购物车最小产品数",
      MaximumShopping: "最大购物车金额",
      MaximumProduct: "购物车最大产品数",
    },
  },
  dsUserSettings: {
    title: "最小购物车条件",
    groupTitle: "用户，谁",
    specialTitle: "用户",
    labels: {
      minimumCart: "最小购物车条件",
      users: "用户",
    },
    items: {
      AllUser: "所有用户",
      group: "用户组",
      special: "特殊用户",
    },
    groupItems: {
      Order: "已购买",
      noOrder: "尚未购买",
    },
  },
  qrAddressUpdate: {
  title: "编辑地址",
  labels: {
    address: "二维码地址",
  },
  hints: {
    allowedChars: "仅允许使用英文字母、数字、连字符 (-) 和下划线 (_)",
  },
  buttons: {
    removeInvalidChars: "删除无效字符",
  },
  errors: {
    minLength: "至少需要 3 个字符",
    invalidChars: "字符无效！只能使用英文字母、数字、- 和 _。",
    invalidAddress: "输入的地址无效",
    updateFailed: "更新地址失败",
  },
  successMessage: "地址更新成功",
  warning: "警告",
  warningMessage: "更改地址后，之前的链接将无法使用。",
  savePrompt: "确定要保存此更改吗？",
},
  dsFunctionType: {
    title: "折扣适用于",
    productListTitle: "产品列表",
    categoryListTitle: "类别列表",
    labels: {
      applyDiscount: "应用折扣到",
      category: "类别",
    },
    items: {
      AllShoppingCart: "购物车总金额",
      SpecialProducts: "特殊产品",
      SpecialCategories: "特殊类别",
    },
  },
  dsLimitationUse: {
    title: "使用限制",
    discountCodeTitle: "码使用次数",
    userTitle: "每用户使用次数",
    labels: {
      limitation: "限制",
      usage: "使用",
      user: "用户",
    },
    items: {
      NoLimitations: "无限制",
      DiscountCode: "折扣码使用次数",
      User: "每用户使用次数",
    },
  },
  ManageHourLimitQr: {
    noLimit: "无限制",
    dateLimit: "日期限制",
    timeLimit: "时间限制",
    startDate: "开始日期",
    endDate: "结束日期",
    selectDate: "选择日期",
    startTime: "开始时间",
    endTime: "结束时间",
  },
  discount_percent_range: "折扣必须在0到100%之间",
  discount_price_range: "折扣必须在0到{max}之间",
  invalid_number: "仅输入数字",
  min_order_cart: "最小订单值",
  preparation_time: "准备时间（分钟）",
  delivery_time: "交付时间（分钟）",
  max_product_in_order: "每订单最大产品数",
  max_order_by_person: "每人最大订单数",
  send_by_courier_price: "快递费用",
  vat: "税率",
  send_by_post: "邮寄费用",
  online_pay: "在线支付",
  pay_in_person_place: "现场支付",
  in_place: "现场取货",
  table_booking_ability: "桌位预订",
  send_by_courier: "快递交付",
  vat_switch: "税",
  invalid_number: "仅输入数字",
  positive_number: "数字必须为正",
  vat_range: "税率必须在0到100%之间",
  sort_column: "排序列",
  direction_sort: "排序方向",
  listFeedbackUser: {
    no_questions: "您没有反馈收集问题",
    add_feedback_prompt: "在'添加'选项卡中创建新反馈",
    question_label: "问题",
    show_answers: "显示答案",
    back_button: "返回",
    no_feedback: "无反馈可用！",
    user_opinion: "用户意见",
    score_label: "评分",
  },
  manageDiscount: {
    createNewDiscount: "创建新折扣码",
    copy: "复制",
    row: "行",
    id: "ID",
    discountCode: "折扣码",
    usageLimit: "使用限制",
    used: "已用",
    manage: "管理",
    edit: "编辑",
    delete: "删除",
    sendSms: "发送短信给目标组",
    copySuccess: "折扣码已复制",
    copyError: "复制出错",
    deleteSuccess: "折扣码已删除",
    deleteError: "删除折扣码出错",
    smsSuccess: "折扣码已发送给目标组",
    smsError: "发送出错",
  },
  manageTableReservation: {
    table: "桌子",
    number: "桌子 {num}",
    add_table: "添加桌子",
    complete_info_for_customer: "填写显示给客户的信息",
    select_image: "选择图片",
    table_name_number: "桌子名称/号码",
    number_of_seats: "座位数",
    type: "类型",
    reservation_cost: "预订费用",
    enter_table_name: "输入桌子名称/号码",
    table_type: "桌子",
    couch_type: "沙发",
    gazebo_type: "凉亭",
  },
  create_menu: {
    data: {
      visitName_label: "访问名称",
      organizationName: "大型快餐连锁",
      subOrgan: "与我们一起尝试最好的快餐味道",
      aboutUs:
        "大型快餐 – 以质量和对客户的尊重，我们提供最好的。\n质量是我们的原则。\n在快餐领域，我们用我们的特殊三明治为快速餐食世界引入了新味道。\n我们每天准备在行政活动、生日等场合为您服务...",
      copyright: "本网站所有权利属于Terminal Advertising。",
      product: {
        title: "产品",
        pizzas: "披萨",
        pizza_roast_beef: "烤牛肉披萨",
        pizza_roast_beef_desc: "🤩 意大利披萨配牛肉",
        pizza_roast_beef_ingredients:
          "意大利披萨底30厘米，100克牛肉末，蘑菇，辣椒，黑橄榄",
        pizza_chicken_mushroom: "鸡肉蘑菇披萨",
        pizza_chicken_mushroom_desc: "🍕 经典40厘米",
        pizza_chicken_mushroom_ingredients:
          "新鲜Pizzara番茄酱，巴氏杀菌奶酪，鸡柳，蘑菇，山百里香",
        pizza_meat_mushroom: "肉蘑菇披萨",
        pizza_meat_mushroom_desc: "🥰 牛肉末和蘑菇披萨",
        pizza_meat_mushroom_ingredients:
          "新鲜Pizzara番茄酱，巴氏杀菌奶酪，牛里脊肉末，蘑菇，山百里香，2人份（29厘米）355,000托曼，1人份（22厘米）216,000托曼",
        pizza_veggie: "素食披萨",
        pizza_veggie_desc: "🍕 美国素食披萨",
        pizza_veggie_ingredients:
          "美国披萨底，甜玉米，蘑菇，橄榄，西红柿，洋葱，辣椒，披萨奶酪",
        pizza_special: "特殊披萨",
        pizza_special_desc: "美国特殊披萨",
        pizza_special_ingredients:
          "美国披萨底，调味牛肉末，汉堡混合牛肉和鸡肉80%，莫扎里拉混合，特殊酱，辣椒，蘑菇，1人份无酱",
        pizza_bolognese: "博洛尼亚披萨",
        pizza_bolognese_desc: "(1人份) 披萨底23厘米 🤌",
        pizza_bolognese_ingredients:
          "牛肉末，莫扎里拉，蘑菇，辣椒，甜玉米，切片黑橄榄",
        pizza_pepperoni: "佩珀罗尼披萨",
        pizza_pepperoni_desc: "(1人份) 披萨底23厘米",
        pizza_pepperoni_ingredients:
          "意大利披萨底，佩珀罗尼80%，马里纳拉酱，特殊披萨奶酪",
        pizza_bacon: "培根披萨",
        pizza_bacon_desc: "(1人份) 披萨底23厘米 💥",
        pizza_bacon_ingredients:
          "意大利披萨底，马里纳拉酱，特殊披萨奶酪，培根混合牛肉和鸡肉90%，蘑菇，橄榄，辣椒",
        pizza_mixed: "混合披萨",
        pizza_mixed_desc: "(1人份) 披萨底23厘米 🤭",
        pizza_mixed_ingredients:
          "汉堡混合牛肉和鸡肉末，萨拉米，牛肉末，蘑菇，橄榄，辣椒，披萨奶酪，特殊酱",
        pizza_american_steak: "美国牛排披萨",
        pizza_american_steak_desc: "(1人份) 23厘米 💥",
        pizza_american_steak_ingredients:
          "美国披萨底，牛肉块，蘑菇，披萨奶酪，芝麻",
        burgers: "汉堡",
        cheeseburger: "芝士汉堡",
        cheeseburger_desc: "🤩 配薯条",
        cheeseburger_ingredients:
          "2个牛肉汉堡饼每个150克，特殊酱，高达奶酪，腌黄瓜，生菜，西红柿",
        hamburger: "汉堡",
        hamburger_desc: "😍 纯牛肉配特殊酱",
        hamburger_ingredients:
          "牛肉汉堡饼150克，腌黄瓜，生菜，特殊酱，西红柿，Mac面包，1人份酱",
        chicken_burger: "鸡肉汉堡",
        chicken_burger_desc: "烤鸡配奶酪",
        chicken_burger_ingredients:
          "150克烤鸡胸，奶酪，西红柿，腌黄瓜，生菜，Mac面包，特殊酱",
        spice_burger: "辣汉堡",
        spice_burger_desc: "牛肉配辣酱",
        spice_burger_ingredients:
          "牛肉汉堡饼130克，辣酱，生菜，西红柿，Mac面包，特殊辣酱",
        double_burger: "双层汉堡",
        double_burger_desc: "牛肉150克",
        double_burger_ingredients:
          "2个手工牛肉饼每个150克，披萨奶酪，焦糖酱，生菜，红卷心菜，白特殊酱，圆面包",
        royal_burger: "皇家汉堡",
        royal_burger_desc: "150克牛肉 🍔",
        royal_burger_ingredients:
          "手工牛肉饼150克，披萨奶酪，5片萨拉米，焦糖酱，生菜，红卷心菜，白特殊酱，圆面包",
        mushroom_burger: "蘑菇汉堡",
        mushroom_burger_desc: "牛肉150克",
        mushroom_burger_ingredients:
          "手工牛肉饼150克，蘑菇，焦糖酱，生菜，红卷心菜，白特殊酱，圆面包，莫扎里拉",
        mashroom_burger: "蘑菇汉堡",
        mashroom_burger_desc: "100%烤牛肉 🤩",
        mashroom_burger_ingredients:
          "手工100%烤牛肉饼，薯条，西红柿，生菜，腌黄瓜，蘑菇酱，圆面包",
        fried_burger: "炸汉堡",
        fried_burger_desc: "100%烤和炸牛肉 👌",
        fried_burger_ingredients:
          "手工100%烤和炸牛肉饼，150克薯条，西红柿，生菜，腌黄瓜，特殊酱，圆面包",
        fried: "炸的",
        fried_chicken: "炸鸡",
        fried_chicken_desc: "😍 3块炸鸡",
        fried_chicken_ingredients:
          "3块炸鸡，120–150克薯条，100–120克凉拌卷心菜，面包卷，特殊酱",
        chicken_strips: "鸡柳",
        chicken_strips_desc: "4块调味辣炸鸡柳",
        chicken_strips_ingredients:
          "4块炸鸡柳，120–150克薯条，100–120克凉拌卷心菜，面包卷，鞑靼酱",
        fried_filet: "炸柳",
        fried_filet_desc: "🤩 2块炸柳配特殊酱",
        fried_filet_ingredients:
          "2块柳条，烤土豆，凉拌卷心菜，面包卷，大蒜酱，泰国辣酱，辣椒酱",
        fried_mushroom_onion: "炸蘑菇和洋葱",
        fried_mushroom_onion_desc: "🤩 炸蘑菇和洋葱配鞑靼酱",
        fried_mushroom_onion_ingredients: "20块炸蘑菇，6块炸洋葱圈，鞑靼酱",
        fried_wings: "炸鸡翅",
        fried_wings_desc: "6块炸鸡翅 🍗",
        fried_wings_ingredients: "六个烤和炸鸡翅",
        fried_chicken_basket: "炸鸡篮",
        fried_chicken_basket_desc: "(2人份) 😍",
        fried_chicken_basket_ingredients:
          "2块炸鸡，2块柳条，2块洋葱圈，2块炸虾块，2块鸡块",
        fried_schnitzel: "炸炸肉排",
        fried_schnitzel_desc: "四块鸡肉炸肉排 💥",
        fried_schnitzel_ingredients: "四个烤和炸调味鸡肉炸肉排",
        veggie_basket_fried: "炸素篮",
        veggie_basket_fried_desc: "250克 🤩",
        veggie_basket_fried_ingredients: "250克，炸西葫芦，茄子，蘑菇，土豆",
        fried_chicken_2_piece: "炸鸡2块",
        fried_chicken_2_piece_desc: "2块炸鸡 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150克薯条，100–120克凉拌卷心菜，面包卷，特殊酱",
        fried_chicken_5_piece: "炸鸡5块",
        fried_chicken_5_piece_desc: "五块炸鸡",
        fried_chicken_5_piece_ingredients:
          "150–200克薯条，两个凉拌卷心菜100–120克，两个面包卷，特殊酱",
        fried_chicken_7_piece: "炸鸡7块",
        fried_chicken_7_piece_desc: "七块炸鸡 💥",
        fried_chicken_7_piece_ingredients:
          "150–200克薯条，凉拌卷心菜100–120克，3个面包卷，特殊酱，1人份炸酱",
        sandwich: "三明治",
        hotdog_sandwich: "热狗三明治",
        hotdog_sandwich_desc: "热狗三明治配蘑菇和奶酪",
        hotdog_sandwich_ingredients:
          "烤热狗香肠，生菜，西红柿，腌黄瓜，蘑菇和披萨奶酪",
        roast_beef_sandwich: "烤牛肉三明治",
        roast_beef_sandwich_desc: "✔️ 牛肉末",
        roast_beef_sandwich_ingredients:
          "牛肉，披萨奶酪，蘑菇，切片土豆脆片，生菜，西红柿，腌黄瓜，特殊酱，法式面包",
        ham_sandwich: "火腿三明治",
        ham_sandwich_desc: "鸡火腿三明治配蘑菇（冷）",
        ham_sandwich_ingredients:
          "鸡火腿配蘑菇，生菜，西红柿，腌黄瓜，切片土豆脆片，特殊酱，法棍",
        bandari_sausage_sandwich: "班达里香肠三明治",
        bandari_sausage_sandwich_desc: "💥 辣班达里三明治",
        bandari_sausage_sandwich_ingredients:
          "班达里菜配烟熏鸡尾酒香肠55%，西红柿，腌黄瓜，特殊酱，洋葱和香菜，大面包",
        tongue_mushroom_sandwich: "舌头蘑菇三明治",
        tongue_mushroom_sandwich_desc: "150克牛舌",
        tongue_mushroom_sandwich_ingredients:
          "蘑菇，巴氏杀菌披萨奶酪，橄榄，甜玉米，生菜，腌黄瓜，西红柿，酱，配菜，薯条，凉拌卷心菜",
        falafel_sandwich: "沙拉三明治",
        falafel_sandwich_desc: "六个沙拉 🌭",
        falafel_sandwich_ingredients:
          "六个沙拉，腌黄瓜，西红柿，生菜，1人份酱，配菜，薯条，凉拌卷心菜",
        cheesy_kebab_turki_sandwich: "奶酪土耳其烤肉三明治",
        cheesy_kebab_turki_sandwich_desc: "150克牛肉",
        cheesy_kebab_turki_sandwich_ingredients:
          "150克牛肉，特殊披萨奶酪，腌黄瓜，西红柿，生菜，1人份酱，薯条，凉拌卷心菜",
        roast_chicken_sandwich: "烤鸡三明治",
        roast_chicken_sandwich_desc: "鸡肉炸肉排和蘑菇 🤩",
        roast_chicken_sandwich_ingredients:
          "鸡肉炸肉排和蘑菇，特殊披萨奶酪，橄榄，甜玉米，芝麻，生菜，辣椒，腌黄瓜，西红柿，特殊酱，配菜，薯条",
        cheesy_indian_sandwich: "印度奶酪三明治",
        cheesy_indian_sandwich_desc: "德国香肠 💥",
        cheesy_indian_sandwich_ingredients:
          "德国奶酪香肠，甜玉米，生菜，蘑菇，特殊酱，配菜，薯条，凉拌卷心菜",
        snack: "小吃",
        chicken_snack: "鸡肉小吃",
        chicken_snack_desc: "😋 鸡胸肉末",
        chicken_snack_ingredients:
          "150克鸡胸，辣椒，蘑菇，特殊小吃面包，特殊酱",
        meat_snack: "肉小吃",
        meat_snack_desc: "🥪 双肉小吃",
        meat_snack_ingredients:
          "双份，牛里脊肉末，莫扎里拉，甜玉米，辣椒，特殊酱，吐司面包",
        chicken_meat_snack: "鸡肉-肉小吃",
        chicken_meat_snack_desc: "🤩 双鸡肉-肉小吃",
        chicken_meat_snack_ingredients:
          "双份，鸡胸肉末，牛里脊肉末，莫扎里拉，甜玉米，辣椒，特殊酱，吐司面包",
        special_snack: "特殊小吃",
        special_snack_desc: "🤤 双特殊小吃",
        special_snack_ingredients:
          "双份，卡尔巴斯混合牛肉和鸡肉90%，莫扎里拉，甜玉米，辣椒，特殊酱，吐司面包",
        roast_beef_snack: "烤牛肉小吃",
        roast_beef_snack_desc: "牛肉末 🍖",
        roast_beef_snack_ingredients:
          "牛肉末，蘑菇，披萨奶酪，辣椒，甜玉米，配菜，薯条，凉拌卷心菜",
        veggie_snack: "素食小吃",
        veggie_snack_desc: "4块素食小吃",
        veggie_snack_ingredients:
          "西兰花，甜玉米，橄榄，饮食披萨奶酪，蘑菇，配菜，薯条，凉拌卷心菜",
        chicken_mushroom_snack: "鸡肉蘑菇小吃",
        chicken_mushroom_snack_desc: "鸡肉炸肉排和蘑菇 👌",
        chicken_mushroom_snack_ingredients:
          "鸡肉炸肉排，蘑菇，特殊披萨奶酪，橄榄，甜玉米，辣椒，配菜，薯条，凉拌卷心菜",
        pepperoni_snack: "佩珀罗尼小吃",
        pepperoni_snack_desc: "卡尔巴斯佩珀罗尼90% 💥",
        pepperoni_snack_ingredients:
          "双份，卡尔巴斯佩珀罗尼90%，莫扎里拉，甜玉米，辣椒，特殊酱",
        bologna_snack: "博洛尼亚小吃",
        bologna_snack_desc: "牛肉末 👌",
        bologna_snack_ingredients:
          "双份，牛肉末，特殊培根，漂白蘑菇，甜玉米，莫扎里拉，辣椒，特殊酱",
        pasta: "意大利面",
        alfredo_pasta: "阿尔弗雷多意大利面",
        alfredo_pasta_desc: "阿尔弗雷多意大利面配特殊蘑菇酱",
        alfredo_pasta_ingredients: "350克通心粉",
        macaroni: "通心粉",
        macaroni_desc: "🥣 肉和蘑菇通心粉",
        macaroni_ingredients:
          "丝带面1,2，100克牛肉末，蘑菇，辣椒，烤土豆丁，豌豆",
        spaghetti_bolognese: "博洛尼亚意大利面",
        spaghetti_bolognese_desc: "🥰 linguine面",
        spaghetti_ingredients:
          "700克，linguine面，牛肉和羊肉末，博洛尼亚酱，特殊红Rasu酱，可选塑料勺叉",
        chicken_stroganoff: "鸡肉斯特罗加诺夫",
        chicken_stroganoff_desc: "😍 鸡肉斯特罗加诺夫配鸡胸块",
        chicken_stroganoff_ingredients:
          "180克调味鸡胸块，奶油，漂白蘑菇，帕尔马干酪，手切薯条，特殊微波容器",
        penne_arrabbiata: "愤怒通心粉",
        penne_arrabbiata_desc: "鸡胸 💥",
        penne_arrabbiata_ingredients:
          "1人份，鸡胸，面，蘑菇，帕尔马干酪，樱桃西红柿，欧芹，愤怒酱",
        chicken_pesto_pasta: "鸡肉香草意大利面",
        chicken_pesto_pasta_desc: "(1人份) 鸡胸",
        chicken_pesto_pasta_ingredients:
          "鸡胸，蘑菇，帕尔马干酪，樱桃西红柿，欧芹，愤怒酱",
        carbonara_pasta: "卡博纳拉意大利面",
        carbonara_pasta_desc: "牛肉培根97%",
        carbonara_pasta_ingredients:
          "面，牛肉培根97%，阿尔弗雷多酱，帕尔马干酪，樱桃西红柿，欧芹",
        appetizer: "开胃菜",
        hot_chips: "热薯片",
        hot_chips_desc: "😙 各种薯片口味",
        hot_chips_ingredients:
          "公斤薯片，特殊酱，鸡火腿70%，蘑菇，辣椒，披萨奶酪，高达",
        lasagna: "千层面",
        lasagna_desc: "牛肉末千层面",
        lasagna_ingredients:
          "3张千层面，牛肉末，蘑菇，辣椒，黑橄榄，披萨奶酪，特殊酱",
        french_fries: "薯条",
        french_fries_desc: "薯条配特制酱汁",
        french_fries_ingredients: "150克薯条，特制酱汁",
        baked_potato: "烤马铃薯",
        baked_potato_desc: "🍟烤马铃薯配牛肉培根",
        baked_potato_ingredients:
          "150克薯条，牛肉培根90%，披萨奶酪，特制香料，单人份酱汁",
        garlic_bread: "蒜香面包",
        garlic_bread_desc: "特制蒜香酱💥",
        garlic_bread_ingredients:
          "美国披萨面团，混合披萨奶酪，特制蒜香酱，芝麻",
        silo_potatoes: "西罗马铃薯",
        silo_potatoes_desc: "双人份薯条",
        silo_potatoes_ingredients:
          "西罗香料薯条，牛肉培根97%，切达酱，蒜蓉蛋黄酱，葱花，欧芹",
        bbq_sausage: "烧烤香肠",
        bbq_sausage_desc: "调味手指香肠🍢",
        bbq_sausage_ingredients:
          "500克调味马铃薯泥，200克调味手指香肠，洋葱圈，绿橄榄，帕玛森奶酪粉，樱桃番茄，微型蔬菜，可烤奶酪，烧烤酱，辣味",
        silo_toast: "西罗吐司",
        silo_toast_desc: "160克牛里脊肉片🤩",
        silo_toast_ingredients:
          "160克牛里脊肉片，法国生菜，牛肉培根，农家面包，烧烤酱，鞑靼酱，高粱，绿橄榄，微型蔬菜，蒜蓉蛋黄酱，帕玛森奶酪粉",
        salad_and_dessert: "沙拉与甜点",
        caesar_salad: "凯撒沙拉",
        caesar_salad_desc: "单人份凯撒沙拉🥗",
        caesar_salad_ingredients:
          "混合生菜，烤鸡，帕玛森奶酪，蒜香面包丁（蒜香面包），凯撒酱，橄榄",
        caesar_salad_extra: "罗马生菜，蒜香面包丁，帕玛森",
        coleslaw_salad: "高丽菜沙拉",
        coleslaw_salad_desc: "单人份高丽菜沙拉🍴",
        coleslaw_salad_ingredients: "手工制作，单人份，白高丽菜，玉米，酱汁",
        macaroni_salad: "通心粉沙拉",
        macaroni_salad_desc: "自家制火腿通心粉沙拉",
        macaroni_salad_ingredients: "通心粉，自家制火腿",
        pachira_salad: "帕奇拉沙拉",
        pachira_salad_desc: "双人份帕奇拉沙拉🥗",
        pachira_salad_ingredients:
          "双人份，混合生菜，牛肉培根脆片98%，焦糖核桃，帕玛森奶酪，草莓，植物鱼子酱，葡萄干，柠檬片，玫瑰莓酱",
        greek_salad: "希腊沙拉",
        greek_salad_desc: "传统希腊沙拉配羊奶酪与橄榄",
        greek_salad_ingredients: "羊奶酪，橄榄，黄瓜",
        tiramisu: "提拉米苏",
        tiramisu_desc: "经典意大利提拉米苏甜点",
        tiramisu_ingredients: "咖啡，马斯卡彭奶酪，可可粉",
        beverages: "饮料",
        local_yogurt_drink: "当地优格饮料",
        local_yogurt_drink_desc: "家庭式当地优格饮料🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "黑汽水",
        black_soda_desc: "杯装黑汽水🧋",
        black_soda_ingredients: "",
        fanta: "黄汽水",
        fanta_desc: "杯装黄汽水🥤",
        fanta_ingredients: "",
        mojito: "莫希托",
        mojito_desc: "杯装莫希托，容量350至400毫升🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "热带麦芽饮料",
        tropical_malt_beverage_desc: "杯装热带麦芽饮料🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "地址",
        address_text: "请输入目标网站链接",
        instagram_label: "Instagram",
        instagram_text: "请输入您的用户名",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "视频画廊",
        description: "为更了解QR-Land智能系统服务，请观看以下视频。",
        tutorial: "教学",
        fast_food: "快餐",
      },
      feedback: {
        title: "您的反馈",
        description: "请通过回答以下问题，协助我们提供更好的服务",
        question1: "您对我们的服务与食物品质满意度如何？",
        question2: "您如何评价餐厅的菜色多样性？",
        question3: "您如何评价餐厅员工的服务态度？",
        question4: "食物是否准时送达？",
        question5: "您是否有任何改进服务或食物品质的建议？",
      },
      worksheet: {
        saturday: "星期六",
        sunday: "星期日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        shift_1_saturday: "10:00 至 22:00",
        shift_1_sunday: "10:00 至 22:00",
        shift_1_monday: "10:00 至 22:00",
        shift_1_tuesday: "10:00 至 22:00",
        shift_1_wednesday: "10:00 至 00:00",
        shift_1_thursday: "10:00 至 00:00",
        shift_1_friday: "10:00 至 00:00",
      },
      gallery: {
        gallery_0: "图库0  ",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "烤马铃薯 2",
        chicken_stroganoff_1: "鸡肉斯特罗加诺夫1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location: "德黑兰，谢里亚提街，赛义德·汉丹桥后，汉丹死巷，6号，3单元",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "伊朗，德黑兰，德黑兰市，德黑兰，德黑兰市3区，赛义德·汉丹社区，阿里·谢里亚提博士，汉丹",
      },
    },
    messages: {
      qr_created_success: "线上菜单已成功建立。",
      qr_updated_success: "您的线上菜单QR已成功编辑。",
      qr_create_error: "建立QR时发生错误！",
      qr_update_error: "储存/编辑QR时发生错误",
      template_categories_saved: "范例模型的分类已成功储存。",
      template_products_saved: "范例模型的产品已成功储存。",
      template_categories_error: "储存范例模型分类时发生错误！",
      template_products_error: "储存范例模型产品时发生错误！",
    },
    sample_menu: "范例菜单",
    view_qr: "检视QR",
    preview: "预览",
    download_qr: "下载QR",
    create_qr: "建立QR",
    online_menu_name: "线上菜单名称",
    online_menu_name_short: "菜单名称",
    enter_qr_address: "请输入QR地址",
    qr_address: "QR地址",
    enter_menu_information: "请输入菜单资讯",
    cleardefaults: "清除预设值",
    select_sample_menu: "选择范例菜单",
    select_ready_menu: "选择现成菜单",
    online_sales: "线上销售",
    sales_settings: "销售设定",
    download: "下载",
    gallery_photos: "图库照片",
    fast_food_1: "快餐图片 1",
    fast_food_2: "快餐图片 2",
    large_chain_fast_food: "大型连锁快餐",
    best_fast_food_taste_experience: "与我们一同体验最佳快餐风味",
    online_menu_created_successfully: "线上菜单已成功建立。",
    qr_creation_failed: "建立QR时发生错误！",
    online_menu_qr_updated_successfully: "您的线上菜单QR已成功编辑。",
    error_saving_updating_qr: "储存/编辑QR时发生错误",
    sample_model_categories_saved_successfully: "范例模型的分类已成功储存。",
    sample_model_products_saved_successfully: "范例模型的产品已成功储存。",
    error_saving_sample_model_products: "储存范例模型产品时发生错误！",
    error_saving_sample_model_categories: "储存范例模型分类时发生错误！",
  },
  editMenu: {
    enter_menu_information: "请输入菜单资讯",
    online_menu_name: "线上菜单名称",
    online_menu_name_short: "线上菜单简称",
    fields: {
      qr_address_hint: "用于存取线上菜单的QR地址",
    },
    online_sales: "线上销售",
    sales_settings: "销售设定",
    shop: {
      upload_banner: "上传横幅",
      create_product: "建立产品",
      user_info: "使用者资讯",
      add_social_media: "新增社群媒体",
      photo_gallery: "图片画廊",
      video_gallery: "视频画廊",
      feedback: "反馈",
      working_hours: "营业时间",
    },
    success_message: "您的名片已成功编辑。",
  },
  qrCodeSquare: {
    dots_color: "点点颜色",
    gradient_color: "渐层色彩",
    linear: "线性",
    radial: "放射状",
    color_rotation: "颜色旋转",
    first_color: "第一种颜色",
    second_color: "第二种颜色",
    dots_color_label: "点点颜色",
  },
  language: {
    selectAll: "全选",
    lang: {
      fa: "波斯语",
      ar: "阿拉伯语",
      ar_ae: "阿拉伯语 (阿联酋)",
      ar_iq: "阿拉伯语 (伊拉克)",
      en_US: "英语 (美国)",
      en_GB: "英语 (英国)",
      de: "德语",
      fr: "法语",
      zh_CN: "简体中文",
      zh_TW: "繁体中文",
      tr: "土耳其语",
      ru: "俄语",
      hy: "亚美尼亚语",
    },
    only_manual_now: "目前仅支持手动翻译",
    ai_coming_soon: "AI 翻译即将上线",
    got_it: "知道了",
    origin_language: "源语言",
    target_languages: "目标语言",
    remove_all: "移除所有语言",
    translation_method: "选择翻译方式",
    manual_translation: "手动翻译",
    ai_translation: "AI 翻译",
    coming_soon: "即将推出",
    source_language_updated: "源语言已更新",
    error_changing_source_language: "更改源语言时出错",
    source_language_created: "已创建新源语言",
    languages_saved: "新语言已保存",
    error_saving_languages: "保存语言时出错",
    error_loading_language: "加载语言时出错",
    languages_removed: "已移除的语言",
    new_languages_to_save: "待保存的新语言",
    saved: "已保存",
    management_langs: "语言管理",
    add_langs: "添加语言",
    change_language: "更改语言",
    visit_card: "名片",
    translate_to: "翻译为",
    main_language: "主语言",
    no_languages_available: "无可用语言",
    return_to_default: "返回默认语言",
    translate: "翻译",
    changes_pending: "等待应用更改",
    apply_changes: "应用更改",
    cancel_changes: "取消",
  },
  winner_list: "中奖名单",
  qrwinnersList: {
    winnerstotalcount: "QR 总获奖人数",
    winnerscountoffilter: "应用过滤后的获奖人数",
    winnersList: "QR中奖名单",
    prize: "奖品",
    winnerName: "中奖人姓名",
    date: "日期",
    noWinners: "暂无中奖记录",
    perPage: "每页显示数量",
    search: "按中奖人或奖品搜索",
    sortDirection: "排序方向",
    sortBy: "排序依据",
  },
  appearance_settings: "外观设置",
  header_color: "头部颜色",
  background_color: "背景颜色",
  text_color: "文本颜色",
  font_size: "字体大小",
  chat_logo: "聊天标志",
  floating_button_icon: "浮动按钮图标",
  assistant_name: "助手名称",
  chat_preview: "聊天预览",
  smart_assistant: "智能助手",
  online: "在线",
  aiChatSettings: {
    select_assistant: "选择助手",
    appearance_settings: "外观设置",
    lead_connection_tab: "领取线索 - 连接客户俱乐部",

    header_settings: "头部设置",
    header_settings_desc: "聊天头部颜色和样式",
    text_settings: "文本设置",
    text_settings_desc: "字体颜色和大小",
    logo_settings: "标志设置",
    logo_settings_desc: "助手照片或图标",
    background_settings: "背景设置",
    background_settings_desc: "背景图片或颜色",

    gradient_color: "渐变颜色",
    solid_color: "纯色",
    use_image: "使用图片",
    use_icon: "使用图标",

    first_color: "第一种颜色",
    second_color: "第二种颜色",
    header_color: "头部颜色",
    text_color: "文本颜色",
    background_color: "背景颜色",

    font_size: "字体大小",

    robot: "机器人",
    chat: "聊天",
    support: "支持",
    question: "问题",
    message: "消息",
    assistant_voice: "助手",
    ai_brain: "人工智能",

    lead_connection_title: "连接客户俱乐部",
    lead_alert:
      "设置这些选项后，当用户选择提交线索时，其信息将被保存在客户俱乐部中。",

    hasAssistantsName_label: "获取姓名",
    hasAssistantsName_hint: "收集用户姓名",
    hasAssistantsFamily_label: "获取姓氏",
    hasAssistantsFamily_hint: "收集用户姓氏",
    hasAssistantsMobile_label: "获取手机号码",
    hasAssistantsMobile_hint: "收集用户手机号码",
  },
  assistantChatViewer: {
    assistant_name: "智能助手",
    online: "在线",
    new_chat: "新聊天",
    clear_chat: "清空聊天",
    close: "关闭",
    message_placeholder: "消息...",
    processing: "处理中...",
    renew: "续订",
    created_at: "创建时间",
    last_edit: "最后编辑",
    copied: "已复制",
    copy: "复制",
    print_qr: "打印二维码",
    print_visit_card: "打印名片",
    send_link: "发送链接",
    winner_list: "获奖名单",
    customer_list: "客户列表",
    order_list: "订单列表",
    reserved_appointments: "预约记录",
    feedback: "反馈",
    request_form: "请求表单",
    transfer_ownership: "转让所有权",
    store_management: "商店管理",
    select_nfc_card: "选择NFC卡",
    edit: "编辑",
    design: "设计",
    qr_settings: "二维码设置",
    deactivate: "停用",
    download: "下载",
    viewed: "次查看",
    see_more: "查看更多",
    updating_qr: "正在更新二维码...",
  },
  create_game: "创建游戏",
  ready_games: "现成游戏",
  add_game: "添加游戏",
  game_gallery: "游戏图库",
  game_size_error: "游戏文件大小不得超过 2MB",
  game_upload_error: "游戏上传错误",
  no_game_available: "没有可用游戏",
  to_use_ready_games_search_category_or_product:
    "使用现成游戏，请按分类或产品搜索",
  gif_size_error: "GIF 文件大小不得超过 2MB",
  previewer_page: "预览显示",
  // ─────────────────────────────────────────────────────
  // 游戏、GIF 和设置部分的翻译键
  // 文件：src/core/services/langs/zh_CN.js
  // 语言：简体中文（Simplified Chinese，适合中国大陆）
  // ─────────────────────────────────────────────────────
  // 1. 主游戏编辑器 (PublicGameEditor)
  game_editor: "游戏编辑器",
  reset_defaults: "恢复默认设置",
  save_and_preview: "保存并预览",
  texts: "文本",
  images: "图像",
  colors: "颜色",
  general_settings: "常规设置",
  gameplay_settings: "游戏玩法设置",
  effects: "特效",
  login_and_phone: "登录与手机号",
  no_settings_available_for_this_game_type: "此游戏类型无可用设置",
  confirm_reset: "确认重置",
  reset_all_settings_to_default: "确定要将所有设置恢复为默认值吗？",
  yes_reset: "是，重置",
  cancel: "取消",
  settings_reset_successfully: "设置已成功重置",
  saved_and_ready_for_preview: "已保存并准备预览",

  // 2. 登录与手机号标签 (TabLogin)
  login_and_phone_settings: "登录与手机号设置",
  ask_phone_after_game: "游戏结束后请求手机号",
  phone_prompt_text: "手机号提示文本",
  phone_prompt_hint: "手机号请求对话框中显示的文本",
  submit_button: "提交按钮",
  login_dialog_logo: "登录对话框logo",
  logo_url: "logo链接",

  // 3. 特效标签 (TabEffect)
  game_effects_settings: "游戏特效设置",
  sound_enabled: "启用音效",
  volume: "音量",
  volume_hint: "游戏音量级别（0 到 1）",
  oscillator_type: "振荡器类型",
  jump_sound_freq: "跳跃音效频率",
  hit_sound_freq: "碰撞音效频率",
  powerup_sound_freq: "强化道具音效频率",
  move_sound_freq: "移动音效频率",
  combo_base_freq: "连击基础频率",
  sound_durations: "音效持续时间",
  move_duration_ms: "移动音效持续时间（毫秒）",
  jump_duration_ms: "跳跃音效持续时间（毫秒）",
  combo_duration_ms: "连击音效持续时间（毫秒）",
  hit_duration_ms: "碰撞音效持续时间（毫秒）",
  vibration_enabled: "启用振动",
  particles_enabled: "启用粒子",
  explosion_settings: "爆炸粒子设置",
  particle_count: "粒子数量",
  gravity: "重力",
  friction: "摩擦力",
  fade_speed: "淡出速度",

  // 4. 图像标签 (TabImages)
  game_images_and_assets: "游戏图像与资源",
  player_image: "玩家图像",
  player: "玩家",
  powerup_image: "强化道具图像",
  qr_powerup: "QR 强化道具",
  enemy_images: "敌人图像",
  optional_multi: "可选，多张图像",
  enemies: "敌人",
  background_image: "背景图像",
  background: "背景",
  phone_frame_background: "手机边框背景",
  phone_frame: "手机边框",
  winner_background: "获胜者背景",
  winner: "获胜者",
  ground_image: "地面图像",
  ground: "地面",
  player_character: "玩家角色",
  far_background_layer: "远景背景层",
  background_far: "远景背景",
  near_background_layer: "近景背景层",
  background_near: "近景背景",
  obstacle_images: "障碍物图像",
  multi_optional: "多张图像，可选",
  obstacles: "障碍物",

  // 5. 文本标签 (TabTexts)
  game_text_contents: "游戏文本内容",
  main_screen_texts: "主屏幕文本",
  game_title: "游戏标题",
  game_subtitle: "游戏副标题",
  start_button: "开始按钮",
  score_label: "分数标签",
  game_over_screen: "游戏结束屏幕",
  game_over_title: "游戏结束标题",
  game_over_subtitle: "游戏结束副标题",
  phone_prompt: "手机号请求",
  restart_button: "重新开始按钮",
  hud_and_labels: "HUD 与标签",
  level_label: "关卡标签",
  combo_label: "连击标签",
  final_score_label: "最终分数标签",
  high_score_label: "最高分标签",
  messages_and_popups: "消息与弹窗",
  new_record_message: "新纪录消息",
  fun_random_messages: "趣味随机消息",
  add_new_message: "添加新消息",

  // 6. 常规设置标签 (TabSetting)
  general_game_settings: "游戏常规设置",
  enemy_spawn_rate: "敌人生成速率",
  frames_between_enemies_spawn: "敌人生成间隔帧数",
  powerup_spawn_rate: "强化道具生成速率",
  frames_between_qr_spawn: "QR 生成间隔帧数",
  win_score_threshold: "胜利分数阈值",
  score_required_for_win_or_phone_prompt: "胜利或显示手机号提示所需分数",
  starting_lives: "初始生命数",
  high_score_storage_key: "最高分存储键",
  phone_prompt_score_threshold: "手机号提示分数阈值",
  score_to_show_phone_number_form: "显示手机号表单的分数",
  no_general_settings_available_for_this_game: "此游戏无常规设置",

  // 7. 游戏玩法标签 (TabGamePlay)
  speed_settings: "速度设置",
  initial_speed: "初始速度",
  max_speed: "最大速度",
  speed_increase_every_frames: "每 X 帧增加速度",
  speed_increase_amount: "速度增加量",
  distance_per_level: "每关距离",
  level_speed_increase: "每关速度增加",
  jump_and_physics: "跳跃与物理",
  jump_force: "跳跃力度",
  max_jump_height: "最大跳跃高度",
  lanes_settings: "车道设置",
  number_of_lanes: "车道数量",
  starting_lane: "起始车道",
  enemies_spawn: "敌人生成",
  traps_spawn: "陷阱生成",
  min_spawn_interval_ms: "最小生成间隔（毫秒）",
  max_spawn_interval_ms: "最大生成间隔（毫秒）",
  same_lane_chance: "同车道概率",
  probability_of_spawn_in_player_lane: "在玩家车道生成的概率",
  collision_tolerance_px: "碰撞容差（像素）",
  scoring_rules: "计分规则",
  hit_penalty: "碰撞惩罚",
  powerup_reward: "强化道具奖励",
  score_speed_divider: "分数速度除数",
  reset_combo_on_hit: "碰撞时重置连击",
  camera_settings: "相机设置",
  normal_zoom: "正常缩放",
  hit_zoom: "碰撞时缩放",
  zoom_lerp_speed: "缩放缓动速度",
  game_end_conditions: "游戏结束条件",
  phone_dialog_score_threshold: "手机号对话框分数阈值",

  // 8. 颜色标签 (TabColors)
  background_gradient: "背景渐变",
  first_color: "第一颜色",
  second_color: "第二颜色",
  particle_hit_color: "碰撞粒子颜色",
  particle_powerup_color: "强化道具粒子颜色",
  main_background_color: "主背景颜色",
  ground_color: "地面颜色",
  hud_colors: "HUD 颜色",
  hud_background: "HUD 背景",
  score_text_color: "分数文本颜色",
  level_text_color: "关卡文本颜色",
  combo_text_color: "连击文本颜色",
  overlay_colors: "叠加层颜色",
  backdrop_color: "背景幕颜色",
  card_background: "卡片背景",
  card_border_color: "卡片边框颜色",
  explosion_particle_color: "爆炸粒子颜色",

  // 9. QR 预览组件 (previewerQr)
  gif_tab: "GIF 标签",
  game_tab: "游戏标签",
  welcome_gif_upload: "上传欢迎 GIF",
  default_welcome: "默认欢迎",
  loading_animation: "加载动画",
  hide_previewer: "隐藏预览",
  show_previewer: "显示预览",
  edit_game_settings: "编辑游戏设置",
  save_and_close: "保存并关闭",
  animation_scale: "动画缩放",
  animation_slide_x: "水平滑动动画",
  animation_slide_y: "垂直滑动动画",
  animation_fade: "淡入淡出动画",
  game_settings_saved: "游戏设置已保存",
  no_game_configured: "未配置游戏",

  gallery_name: "图库名称",
  change_gallery_name: "更改图库名称",
  add_gif: "添加 GIF",
  select_gif: "选择 GIF",
  show_gif: "显示 GIF",
  selected_gif: "已选 GIF",
  count: "数量",
  select_category: "选择分类",
  after_typing_enter: "输入后按 Enter",
  search: "搜索",
  no_gif_available: "无可用 GIF",
  to_use_ready_gifs_search_category_or_product:
    "使用现成 GIF，请按分类或产品搜索",
  max_file_size_2mb: "文件大小上限 2MB",
  upload_file: "上传文件",
  drag_and_drop_to_upload_or: "拖拽上传或",
  here: "此处",
  click: "点击",
  all: "全部",
  no_gif_found: "未找到 GIF",
  for_adding_file_use_upload_center: "添加文件请使用上传中心",
  to_use_external_gif_link_fill_fields: "使用外部 GIF 链接，请填写字段",
  gif_url_hint: "GIF 文件完整网址",
  gif_url: "GIF 网址",
  add: "添加",
  title: "标题",
  link: "链接",
  description: "描述",
  add_new_gallery: "添加新图库",
  enter_valid_link: "输入有效链接",
  create_gif: "创建 GIF",
  ready_gifs: "现成 GIF",
  gif_gallery: "GIF 图库",
  edit_gif: "编辑 GIF",
  max_background_gif_size_2mb: "背景 GIF 大小上限 2MB",
  uploaded_successfully: "上传成功",
  gif_upload_error: "GIF 上传错误",

  preview: "预览",
  start_button_text: "开始按钮文本",
  game_over_text: "游戏结束文本",
  game_over_subtext: "游戏结束副文本",
  mobile_prompt_text: "手机提示文本",
  submit_button_text: "提交按钮文本",
  optional: "可选",
  game_background: "游戏背景",
  background_gradient_colors: "背景渐变颜色",
  frames_per_enemy: "每敌人帧数",
  frames_per_powerup: "每强化道具帧数",
  win_threshold: "胜利阈值",
  score_to_win: "获胜所需分数",
  your_work_page_name: "个人/公司 Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF画廊显示模式",
    "display_mode_label": "显示模式",
    "layout": {
      "list": "列表视图",
      "accordion": "手风琴视图",
      "slider": "滑块视图"
    },
    "gallery_name": "画廊名称",
    "selected_gallery": "选定的画廊",
    "add_file": "添加文件",
    "pdf_gallery_label": "PDF画廊",
    "select_file": "选择文件",
    "title": "标题",
    "pdf_url": "PDF网址",
    "description": "描述",
    "add_button": "添加",
    "all": "全部",
    "image_gallery": "图片画廊",
    "edit_pdf": "编辑PDF",
    "preview": "预览",
    "add_pdf_gallery": "添加PDF画廊",
    "default_gallery_name": "画廊",
    "gallery_prefix": "画廊",
    "tabs": {
      "add_file": "添加文件",
      "pdf_gallery": "PDF画廊",
      "link": "链接"
    },
    "messages": {
      "file_too_large": "文件大小不能超过10 MB。",
      "invalid_file_type": "请仅选择文档和文本文件。",
      "upload_error": "上传文件时出错。",
      "only_pdf_txt_allowed": "只能添加PDF和TXT文件。",
      "title_url_required": "请输入标题和文件网址。"
    }
  },
  "special_info_desc": {
    "textCards": "添加文本卡片以显示用户信息，如描述、背景或简短的个人简介。",
    "customerClubSettings": "设置在用户注册其号码后发送的客户俱乐部会员消息。",
    "advanceSettings": "管理高级和智能设置以自定义页面行为和功能。",
    "voiceGallery": "上传和管理在页面上播放的音频文件。",
    "VideoGallery": "添加并显示用于介绍、培训或内容展示的视频。",
    "imageUploader": "上传要在画廊或页面的不同部分中显示的图片。",
    "colorPallete": "选择自定义颜色以个性化页面设计和外观。",
    "socialMediaIcons": "添加社交媒体链接以便用户快速访问。",
    "pdfSelector": "上传并显示PDF文件供用户查看或下载。",
    "FeedBack": "接收用户关于服务或内容的评论和反馈。",
    "consultationNew": "创建一个表单，供用户提交请求、获取咨询或联系。"
  },
  "voice_gallery": {
    "autoplay_warning": "您一次只能设置一个音频文件自动播放。",
    "autoplay": "自动播放"
  },
  "card": {
    "consultation": {
      "title": "请求表单"
    },
    "form": {
      "name": "名字",
      "surname": "姓氏",
      "phone": "手机号码",
      "email": "电子邮件",
      "address": "地址",
      "national_id": "身份证号",
      "location": "位置",
      "description": "描述"
    },
    "feedback": {
      "title": "您的反馈",
      "description": "请回答以下问题，帮助我们改进服务：",
      "q1": "您对QRLand服务有多满意？",
      "q2": "QRLand服务在多大程度上满足了您的需求？",
      "q3": "为所获服务支付的费用合理度如何？",
      "q4": "与我们分享您的想法以改善我们的服务。"
    },
    "pdf": {
      "gallery_name": "QRLand提案画廊",
      "item1_title": "产品介绍提案",
      "item1_desc": "全面介绍QRLand服务，智能QR码的工作原理，对企业的好处以及用例。",
      "item2_title": "数字名片提案",
      "item2_desc": "介绍QRLand数字名片，快速分享联系信息，社交媒体链接和CRM的功能。"
    },
    "pdf_selector": {
      "title": "PDF画廊",
      "description": "描述"
    },
    "info": {
      "visit_name": "QRLand / 数字名片",
      "organization_name": "QRLand",
      "sub_organ": "首个动态QR生成器平台",
      "user_name": "数字名片",
      "fax": "传真：02191016066",
      "location_desc": "德黑兰，Shariati街，Seyed Khandan桥后，Khandan巷，6号",
      "postal_code": "邮政编码：1541946815",
      "about_us": "由于实体名片存在的问题，QRLand平台推出了一款名为“数字名片”的产品。利用数字技术，它彻底消除了实体名片的局限性，同时通过使用智能替代品，防止过度砍伐树木。",
      "full_address": "伊朗，德黑兰省，德黑兰，第3区，Seyed Khandan社区，Dr. Ali Shariati，Khandan"
    },
    "extra": {
      "field1": "🟥 为您自己的企业创建一张类似的数字名片。\n🟧 免费测试3天。\n🟨 点击这里免费注册。",
      "field2": "您的数字名片具有动态QR码。您可以随时通过手机编辑信息。编辑后，您的QR码永远不会改变。",
      "field3": "💲 拥有此名片的费用为90万土曼。"
    },
    "gallery": {
      "name": "我们将永远站在您身边..."
    },
    "social": {
      "address_hint": "请输入您的地址",
      "address_label": "地址",
      "instagram_hint": "请输入您的Instagram网址",
      "instagram_label": "Instagram",
      "whatsapp_hint": "请输入您的WhatsApp网址",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "为什么选择QRLand名片？QRLand有什么不同？",
      "item1_title": "为什么选择QRLand名片",
      "item2_name": "QRLand数字名片介绍",
      "item2_title": "实体名片的最佳替代品"
    },
    "club": {
      "title": "客户俱乐部会员",
      "description": "这不是一个普通的客户俱乐部！\n注册您的号码"
    },
    "audio": {
      "category_all": "全部",
      "item1_title": "数字名片综合指南",
      "diff_seconds": "1秒前"
    }
  },
  "pic": {
    "background_image": "背景图片",
    "image_display_type": "图片显示类型",
    "image_orientation": "图片方向：",
    "horizontal": "水平",
    "vertical": "垂直",
    "change_display_mode": "更改显示模式",
    "image": "图片",
    "uploaded_image": "上传的图片"
  },
   "send_limit_per_user": "每位用户发送限制 (0 = 不限)",
    "enable_discount_code": "启用折扣码",
    "add_new_discount_code": "添加新折扣码",
    "no_discount_codes_added": "尚未添加折扣码",
"toolsManagment": "管理工具",
"gateway": {
  "edit": "编辑",
  "integrated_edit_all_sections": "所有部分的一体化编辑",
  "show_descriptions": "显示描述",
  "search_section_placeholder": "搜索部门...",
  "no_section_found": "未找到以此命名的部门。",
  "back_to_menu": "返回菜单",
  "cancel": "取消",
  "save": "保存"
},
"gridShow": "网格视图",
"tableShow": "表格视图",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "添加文本卡片，用于展示用户信息，例如描述、经历或简短介绍。",

    customer_club_settings_description:
      "设置客户俱乐部入会消息，用户注册手机号后将收到该消息。",

    advance_settings_description:
      "管理高级和智能设置，以个性化页面的行为和功能。",

    voice_gallery_description:
      "上传和管理可在页面上播放的音频文件。",

    video_gallery_description:
      "添加并展示用于介绍、培训或内容展示的视频。",

    image_uploader_description:
      "上传图片，用于在图库或页面的不同区域中展示。",

    color_palette_description:
      "选择自定义颜色，以个性化页面的外观和设计。",

    social_media_icons_description:
      "添加社交媒体链接，方便用户快速访问。",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "上传或更换商场的主横幅图片。",

    logo_select_description:
      "设置企业或商场的徽标。",

    service_description:
      "管理商场的主要服务和设施。",

    faq_description:
      "添加和编辑客户常见问题。",

    blog_description:
      "添加与商场相关的文章和新闻。",

    floor_description:
      "管理商场的楼层和商铺单元。",

    text_cards_description:
      "输入描述和相关用户信息。",

    social_media_icons_description:
      "添加社交媒体链接，方便客户联系。",

    pic_selector_description:
      "添加商场和商店的图片。",

    video_gallery_description:
      "上传介绍视频或宣传视频。",

    pdf_selector_description:
      "管理目录和信息指南文件。",

    feedback_description:
      "管理访客意见和反馈区域。",

    consultation_new_description:
      "管理用于收集客户信息或需求的表单。",

    service_section_description:
      "创建专属服务区域。",

    counter_service_description:
      "以数字形式展示商场的统计数据和成就。",

    counter_description:
      "设置活动或开业倒计时。",

    personnel_description:
      "介绍管理人员和核心团队成员。",

    customer_club_settings_description:
      "管理短信和客户俱乐部注册设置。",

    work_sheet_description:
      "设置商场的营业时间和营业日。",

    pallet_commercial_description:
      "设置页面的配色和视觉风格。",

    default_description:
      "在企业页面中添加和管理 {title} 部分。",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "设置登录页面并更换商店徽标。",

  banner_selector_description:
    "上传和管理商店横幅。",

  text_cards_description:
    "文本信息、店铺介绍和关于我们。",

  product_description:
    "创建、管理和编辑商品。",

  special_category_manager_description:
    "管理特别优惠和折扣商品的分类。",

  social_media_icons_description:
    "添加商店的社交媒体链接。",

  blog_description:
    "撰写和管理博客文章。",

  service_description:
    "介绍提供的附加服务。",

  faq_description:
    "展示和管理常见问题列表。",

  pic_selector_description:
    "上传和管理商店图片库。",

  video_gallery_description:
    "上传介绍视频和宣传视频。",

  pdf_selector_description:
    "提供指南文件或 PDF 商品目录。",

  feedback_description:
    "管理客户评价和反馈。",

  counter_description:
    "设置活动或特别优惠的倒计时。",

  consultation_description:
    "创建用于接收需求或咨询申请的表单。",

  service_section_description:
    "管理专属服务区域。",

  counter_service_description:
    "展示商店的统计数据、数字和成就。",

  personnel_description:
    "介绍团队成员和商店工作人员。",

  work_sheet_description:
    "设置商店的营业日期和工作时间。",

  default_description:
    "在商店页面中添加和管理 {title} 部分。",
},
edit_gold_special_info_single: {
  product_info_title: "产品信息",
  product_info_description:
    "添加和编辑产品的基本信息、特性、价格及补充说明。",

  asset_management_title: "资产管理",
  asset_management_description:
    "管理资产、分配价值以及与产品相关的钱包信息。",

  add_social_networks_title: "添加社交网络",
  social_networks_title: "社交网络",
  social_media_description:
    "添加社交媒体链接，让客户更快速地与您的品牌取得联系。",

  add_video_title: "添加视频",
  video_description:
    "添加并展示产品介绍、教学或宣传视频。",

  add_image_title: "添加图片",
  image_description:
    "上传不同角度的高质量产品图片，以便在图库中更好地展示产品。",

  select_color_title: "选择颜色",
  color_palette_description:
    "根据您的品牌形象自定义产品展示页面的配色和外观。",
},

edit_multicard_special_info_single: {
  add_account_description:
    "编辑名称、头像和背景",

  management_account_description:
    "添加和编辑银行账户信息",

  management_color_description:
    "更改按钮和背景的颜色主题",
},

edit_feedback_special_single: {
  base_info_description:
    "编辑基本信息和表单标题",

  image_uploader_description:
    "上传和管理反馈表单的徽标",

  feedback_description:
    "设置字段并管理反馈表单",

  color_palette_description:
    "选择配色主题并自定义表单外观",
},

edit_gitf_special_info_single: {
  default_description:
    "在回忆 QR 相框中添加和管理 {title} 部分。",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "目录的基本信息、标题和描述",

  image_uploader_description:
    "上传和管理徽标或主图片",

  pic_selector_description:
    "上传和管理目录或宣传册页面",

  social_media_icons_description:
    "添加和管理社交媒体链接",

  color_palette_description:
    "选择配色主题并自定义外观",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "选择模板以应用不同的分类方式",

  login_config_description:
    "登录页面设置和外观",

  general_settings_description:
    "货币和业务类型的常规设置。",

  banner_selector_description:
    "上传并选择显示在页面顶部的横幅图片，让菜单或个人资料的外观更加吸引人。",

  product_description:
    "创建和管理产品或服务，包括图片、价格和自定义描述等详细信息。",

  text_cards_description:
    "添加文本卡片，用于展示用户的基本信息，例如常规描述、经历或简短介绍。",

  social_media_description:
    "添加社交媒体链接和图标，以便客户更快速地联系和访问。",

  photo_gallery_description:
    "创建图片库，用于展示产品照片、作品集或企业环境。",

  video_gallery_description:
    "添加视频库，用于展示宣传片、教学视频或介绍视频。",

  feedback_description:
    "创建一个区域，用于展示客户评价、反馈以及过往客户的满意度。",

  working_hours_description:
    "设置工作时间和营业时间。",
},

edit_pdf_special_info_single: {
  base_info_title: "信息",
  base_info_description:
    "添加文本卡片，用于展示用户的基本信息，例如常规描述、经历或简短介绍。",

  image_uploader_title: "上传徽标",
  image_uploader_description:
    "上传并选择图片作为徽标或头像，在页面上进行展示。",

  pdf_selector_title: "添加 PDF 图库",
  pdf_selector_description:
    "创建 PDF 或文本文件图库，并可为每个文件添加封面图片和自定义说明。",

  social_media_icons_title: "添加社交网络",
  social_media_icons_description:
    "添加社交媒体链接和图标，以便更快速地联系和访问。",

  color_palette_title: "选择颜色",
  color_palette_description:
    "选择主题颜色并自定义元素外观，使其更符合您的品牌。",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "在照片图库中添加和管理 {title} 部分。",
},

edi_social_special_info_single: {
  banner_selector_title: "上传照片",
  banner_selector_description:
    "选择并上传社交媒体页面顶部的背景图片或横幅。",

  base_info_title: "信息",
  base_info_description:
    "输入主要标题和个人资料描述等基本信息。",

  image_uploader_title: "上传徽标",
  image_uploader_description:
    "上传个人徽标、品牌徽标或头像，以便在页面上展示。",

  social_media_icons_title: "添加社交网络",
  social_media_icons_description:
    "添加 Instagram、Telegram、WhatsApp、LinkedIn 及其他社交网络的链接，以便在页面上显示其图标。",
},

edit_text_special_info_single: {
  base_info_title: "QR 信息和文本",
  base_info_subtitle: "主要文本和文本字段",
  base_info_description:
    "编辑标题、关于我们的主要文本以及自定义 QR 文本字段",

  image_uploader_title: "徽标和背景图片",
  image_uploader_subtitle: "图片设置",
  image_uploader_description:
    "上传和更换自定义徽标或卡片背景图片",

  color_palette_subtitle: "自定义外观",
  color_palette_description:
    "设置标题、背景和文本颜色，以提高可读性和对比度",
},

edit_video_special_info_single: {
  base_info_title: "信息",
  base_info_description:
    "编辑标题和 QR 码地址等基本信息。",

  image_uploader_title: "上传徽标",
  image_uploader_description:
    "上传和管理页面徽标图片。",

  video_gallery_title: "视频图库",
  video_gallery_description:
    "添加、编辑和管理要在图库中显示的视频。",

  social_media_icons_title: "添加社交网络",
  social_media_icons_description:
    "添加社交媒体链接和联系方式。",

  color_palette_title: "选择颜色",
  color_palette_description:
    "更改配色方案并为页面选择合适的颜色主题。",
},

edit_product_special_info_single: {
  factory_info_description:
    "编辑企业信息和介绍",

  single_product_editor_description:
    "编辑主要信息和购买等操作按钮",

  customer_club_settings_description:
    "客户俱乐部设置和短信发送",

  advance_settings_description:
    "高级展示和安全设置",

  features_description:
    "管理产品特性和技术规格",

  voice_gallery_description:
    "上传和管理播客及音频文件",

  image_uploader_description:
    "上传和管理产品图片库",

  video_gallery_description:
    "添加和管理相关视频图库",

  social_media_icons_description:
    "添加和管理社交媒体链接",

  color_palette_description:
    "选择配色主题并自定义模板",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "输入生产企业的基本信息并进行介绍。",

  single_product_editor_description:
    "设置产品的主要信息、信任徽章和购买按钮。",

  customer_club_settings_description:
    "短信设置和客户俱乐部会员设置。",

  features_description:
    "添加产品特性和技术规格。",

  feedback_description:
    "买家评价和反馈区域。",

  consultation_description:
    "咨询申请或订单表单。",

  advance_settings_description:
    "高级和智能产品展示设置。",

  voice_gallery_description:
    "用于产品介绍或指南的音频文件。",

  image_uploader_description:
    "上传产品的不同图片。",

  video_gallery_description:
    "与产品相关的介绍或教学视频。",

  social_media_icons_description:
    "用于进一步沟通的社交媒体链接。",

  color_palette_description:
    "设置产品页面的配色和视觉样式。",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "音频图库基本信息和规格",

  image_uploader_description:
    "上传和管理徽标或封面图片",

  voice_gallery_description:
    "上传和管理音频文件及播客",

  color_palette_description:
    "选择配色主题并自定义图库外观",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "编辑图库标题和描述",

  image_uploader_description:
    "上传和管理徽标及主封面",

  voice_gallery_acc_description:
    "上传、删除和管理音频文件",

  social_media_icons_description:
    "添加和管理社交媒体链接",

  color_palette_description:
    "选择配色主题并自定义图库外观",
},
edit_bpage_special_info_special: {
  advertising_sites: "广告网站",
stores: "商店",

divar: "Divar",
divar_hint: "请输入 Divar 链接",

sheypoor: "Sheypoor",
sheypoor_hint: "请输入 Sheypoor 链接",

digikala: "Digikala",
digikala_hint: "请输入 Digikala 链接",

basalam: "Basalam",
basalam_hint: "请输入 Basalam 链接",

snappshop: "SnappShop",
snappshop_hint: "请输入 SnappShop 链接",

technolife: "Technolife",
technolife_hint: "请输入 Technolife 链接",

torob: "Torob",
torob_hint: "请输入 Torob 链接",

emalls: "eMalls",
emalls_hint: "请输入 eMalls 链接",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "请输入 Cafe Bazaar 链接",

googleplay: "Google Play",
googleplay_hint: "请输入 Google Play 链接",

samsung: "三星",
samsung_hint: "请输入 Galaxy Store 链接",

apple: "苹果",
apple_hint: "请输入 App Store 链接",
  add_audio_gallery: "添加音频文件库",
  factory_information: "企业信息",
  trust_badge: "信任徽章",
  buy_button: "购买按钮",
  smart_settings: "智能设置",
  add_product_feature: "添加产品特性",
  product_features: "产品特性",
  add_audio_file: "添加音频文件",
  audio_gallery: "音频库",
  text: "文本",
  logo_background: "徽标 / 背景",
  select_color: "选择颜色",
  information: "信息",
  luck_management: "幸运管理",
  registration_management: "注册管理",
  turning: "翻页",
  slider: "滑块",
  vertical: "垂直",
  upload_catalog_brochure_images: "上传目录 / 宣传册图片",
  upload_banner: "上传横幅",
  upload_header_image: "上传页眉图片",
  upload_image: "上传图片",
  services: "服务",
  faq: "常见问题",
  blog: "博客",
  create_product: "创建产品",
  user_information: "用户信息",
  add_social_media: "添加社交媒体",
  photo_gallery: "图片库",
  video_gallery: "视频库",
  pdf_gallery: "PDF 文件库",
  feedback: "反馈",
  request_form: "申请表",
  create_section: "创建版块",
  achievements: "成就",
  countdown: "倒计时",
  team_members: "团队成员",
  working_hours: "工作时间",
  upload_logo: "上传徽标",
  create_store: "创建商店",
  customer_club_membership_sms: "客户俱乐部会员短信",
  product_information: "产品信息",
  asset_management: "资源管理",
  social_media: "社交媒体",
  add_video: "添加视频",
  add_image: "添加图片",
  add_user_information: "添加用户信息",
  manage_accounts: "管理账户",
  manage_color: "管理颜色",
  download_qr: "下载二维码",
  add_store: "添加商店",
  manage_appointments: "管理预约",
},
edit_gift_special_info_special: {
  gift_story: "礼物故事",
  profile_image: "个人头像",
  featured_images: "精选图片",
  image_gallery: "图片库",
  video_gallery: "视频库",
  add_audio_file: "添加音频文件",
  select_color: "选择颜色",
},
edit_insurance_special_info_special: {
  login_settings: "登录设置",
  shop_logo_images: "商店徽标和图片",
  login_page_information: "登录页面信息",
  upload_banner_logo: "上传横幅和徽标",
  user_information: "用户信息",
  manage_products_insurance: "管理产品 / 保险",
  special_sale: "特价销售",
  add_social_media: "添加社交媒体",
  blog: "博客",
  services: "服务",
  faq: "常见问题",
  photo_gallery: "图片库",
  video_gallery: "视频库",
  pdf_gallery: "PDF 文件库",
  feedback: "反馈",
  countdown: "倒计时",
  request_form: "申请表",
  create_section: "创建版块",
  achievements: "成就",
  team_members: "团队成员",
  working_hours: "工作时间",
  shop_login_description: "商店徽标和登录页面设置",
  insurance_manage_description: "添加和编辑产品 / 服务列表",
  banner_description: "管理页眉图片",
},
  };
